import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  pl: {
    translation: {
      // Login screen
      "Log in": "Zaloguj się",
      "Email address": "Adres e-mail",
      "Enter pin code from email": "Wprowadź kod PIN z e-maila",
      "Select Workspace": "Wybierz przestrzeń roboczą",
      "Want to use another account? <clickHereLink>Click here</clickHereLink> to logout.": "Chcesz użyć innego konta? <clickHereLink>Wyloguj się</clickHereLink>.",
      "You have more than one available workspace. Please select one.": "Masz więcej niż jedną dostępną przestrzenią roboczą. Proszę wybierz jedną.",
      "to logout.": "aby się wylogować.",
      "Submit login": "Zaloguj",
      "Go back": "Wróć",
      "Send pin code": "Wyślij kod PIN",
      "Pin code": "Kod PIN",
      "First name and last name": "Imię i nazwisko",
      "Edit profile": "Edytuj profil",
      "Change email": "Zmień e-mail",
      "Confirm email change": "Potwierdź zmianę e-maila",
      "First name": "Imię",
      "Last name": "Nazwisko",
      "Update profile": "Zaktualizuj profil",
      "Profile": "Profil",
      "Workspace": "Przestrzeń robocza",
      "Logout": "Wyloguj",
      "Log out": "Wyloguj się",
      "Register": "Zarejestruj się",
      "Workspace name": "Nazwa przestrzeni roboczej",
      "Company name": "Nazwa firmy",
      "Subscription tariff": "Taryfa abonamentowa",
      "Account details": "Dane konta",
      "Enterprise inquiry": "Zapytanie o plan Enterprise",
      "Consents": "Zgody",
      "Create your account": "Utwórz swoje konto",
      "Update was not successfull. Please contact support.": "Aktualizacja nie powiodła się. Proszę skontaktować się z obsługą.",
      "Registration successful. Please login to continue.": "Rejestracja zakończona pomyślnie. Proszę zalogować się, aby kontynuować.",
      "Registration failed. Please try again.": "Rejestracja nie powiodła się. Proszę spróbować ponownie.",
      "Workspace updated successfully": "Przestrzeń robocza zaktualizowana pomyślnie",
      "Workspace update failed": "Przestrzeń robocza nie została zaktualizowana",
      "Profile updated successfully": "Profil zaktualizowany pomyślnie",
      "Profile update failed": "Profil nie został zaktualizowany",
      // Biometric login / WebAuthn login
      "Biometric login": "Logowanie biometryczne",
      "Set up biometric login": "Skonfiguruj logowanie biometryczne",
      "Biometric sign-in was cancelled or is not available on this device.": "Logowanie biometryczne zostało anulowane lub nie jest dostępne na tym urządzeniu.",
      "Biometric registration was cancelled or is not available on this device.": "Rejestracja logowania biometrycznego została anulowana lub nie jest dostępna na tym urządzeniu.",
      "Failed to start biometric registration": "Nie udało się rozpocząć rejestracji logowania biometrycznego",
      "Passkey registered successfully": "Klucz dostępu zarejestrowany pomyślnie",
      "Failed to register passkey": "Nie udało się zarejestrować klucza dostępu",
      "Passkey removed": "Klucz dostępu usunięty",
      "Failed to remove passkey": "Nie udało się usunąć klucza dostępu",
      "Passkey": "Klucz dostępu",
      "Last used {{date}}": "Ostatnio użyty {{date}}",
      "Registered {{date}}": "Zarejestrowano {{date}}",
      "You have no passkeys registered yet.": "Nie masz jeszcze zarejestrowanych kluczy dostępu.",
      "Device name": "Nazwa urządzenia",
      "e.g. Work laptop": "np. Laptop służbowy",
      "{{browser}} on {{os}}": "{{browser}} na {{os}}",
      "Set up biometric login (Face ID, Touch ID, Windows Hello) for faster, more secure sign-in next time. You can also do this later from your profile settings.": "Skonfiguruj logowanie biometryczne (Face ID, Touch ID, Windows Hello), aby logować się szybciej i bezpieczniej. Możesz to również zrobić później w ustawieniach profilu.",
      "Maybe later": "Może później",
      // Google login
      "or": "lub",
      "Google sign-in failed. Please try again.": "Logowanie przez Google nie powiodło się. Spróbuj ponownie.",
      "Complete your profile": "Uzupełnij swój profil",
      "Please provide your first and last name to complete your profile.": "Podaj imię i nazwisko, aby uzupełnić swój profil.",
      "Change subscription": "Zmień abonament",
      "Change subscription successfully": "Abonament zmieniony pomyślnie",
      "Change subscription failed": "Abonament nie został zmieniony",
      "Available subscription plans": "Dostępne plany abonamentowe",
      "Subscription plans": "Plany abonamentowe",
      "Price": "Cena",
      "Equipment limit": "Limit urządzeń",
      "Update subscription": "Zaktualizuj abonament",
      "Selected subscription": "Wybrany abonament",
      "Subscription": "Abonament",
      "Plan": "Plan",
      "State": "Stan",
      "Paid until": "Opłacony do",
      "Total price": "Cena całkowita",
      "No subscription information available": "Brak informacji o abonamencie",
      "No subscription plans available": "Brak dostępnych planów abonamentowych",
      // Subscription plans - billing lifecycle
      "Past due": "Zaległa płatność",
      "Canceled": "Anulowany",
      "Billing period": "Okres rozliczeniowy",
      "Active devices": "Aktywne urządzenia",
      "Count at last month close": "Stan na koniec ostatniego miesiąca",
      "Scheduled change": "Zaplanowana zmiana",
      "Payment": "Płatność",
      "Every piece of equipment that is not archived counts towards the plan limit, whether it is rented out, serviced or in stock. Archive equipment you no longer service to free up the limit.": "Do limitu planu wlicza się każde urządzenie, które nie jest zarchiwizowane — wydzierżawione, serwisowane czy leżące w magazynie. Zarchiwizuj urządzenia, których już nie obsługujesz, aby zwolnić limit.",
      "Taken on the 1st of every month — the active devices as the previous month ended. This is the number checked against the plan limit. Shown as \"—\" until the first month close.": "Ustalana 1. dnia każdego miesiąca — liczba aktywnych urządzeń na koniec poprzedniego miesiąca. To ona jest porównywana z limitem planu. Do pierwszego zamknięcia miesiąca wyświetlane jest „—”.",
      "You have {{count}} active devices — more than this plan allows. Archive equipment you no longer service or pick a bigger plan.": "Masz {{count}} aktywnych urządzeń — więcej, niż pozwala ten plan. Zarchiwizuj urządzenia, których już nie obsługujesz, lub wybierz większy plan.",
      "Archive equipment you no longer service or choose a bigger plan before the next month close, or access will be blocked.": "Zarchiwizuj urządzenia, których już nie obsługujesz, lub wybierz większy plan przed końcem miesiąca — w przeciwnym razie dostęp zostanie zablokowany.",
      "No charge during the trial. When it ends, add a payment card — a prorated amount for the rest of that month is charged to it, then the full plan fee on the 1st of every month, in advance.": "W okresie próbnym nie pobieramy opłat. Po jego zakończeniu dodaj kartę płatniczą — pobierzemy z niej opłatę proporcjonalną do końca bieżącego miesiąca, a następnie pełną opłatę za plan 1. dnia każdego miesiąca, z góry.",
      "The plan fee is charged automatically to your saved card in advance on the 1st of each calendar month. An upgrade is charged immediately (prorated); a downgrade takes effect and is charged from the 1st of next month.": "Opłata za plan pobierana jest automatycznie z zapisanej karty z góry 1. dnia każdego miesiąca kalendarzowego. Zmiana na wyższy plan jest płatna od razu (proporcjonalnie), a zmiana na niższy plan zaczyna obowiązywać i jest naliczana od 1. dnia kolejnego miesiąca.",
      "Manage subscription": "Zarządzaj abonamentem",
      "Individual pricing per active device": "Wycena indywidualna za aktywne urządzenie",
      "Individual pricing": "Wycena indywidualna",
      "We will contact you to discuss pricing.": "Skontaktujemy się z Tobą, aby omówić wycenę.",
      "Every plan starts with a free {{days}}-day trial — no charge until it ends.": "Każdy plan zaczyna się od bezpłatnego {{days}}-dniowego okresu próbnego — do jego zakończenia nie pobieramy opłat.",
      "Please choose a subscription plan.": "Wybierz plan subskrypcji.",
      "Enterprise pricing is individual. Leave a contact and we will reach out to discuss it.": "Wycena planu Enterprise jest indywidualna. Zostaw kontakt, a odezwiemy się, aby ją omówić.",
      "Upgrade takes effect immediately.": "Zmiana na wyższy plan wchodzi w życie natychmiast.",
      "Prorated charge": "Opłata proporcjonalna",
      "Next month": "Kolejny miesiąc",
      "net": "netto",
      "/ month": "/ mies.",
      "Prices shown are net. {{rate}}% VAT will be added.": "Podane ceny są cenami netto. Do każdej kwoty zostanie doliczony podatek VAT {{rate}}%.",
      "Enterprise plan": "Plan Enterprise",
      "Leave a contact — we will reach out to discuss the details of the Enterprise plan.": "Zostaw numer telefonu lub e-mail — odezwiemy się, aby omówić szczegóły planu Enterprise.",
      "Enter a valid email address or phone number.": "Podaj poprawny adres e-mail lub numer telefonu.",
      "Phone or email for contact": "Telefon lub e-mail do kontaktu",
      "Preferred contact date and time (optional)": "Preferowany termin kontaktu (opcjonalnie)",
      "Send request": "Wyślij zgłoszenie",
      "Request sent. We will contact you soon.": "Zgłoszenie wysłane. Wkrótce się z Tobą skontaktujemy.",
      "Downgrade to {{plan}} takes effect on {{date}}.": "Zmiana na plan {{plan}} nastąpi {{date}}.",
      "During the trial, plan changes are free.": "W okresie próbnym zmiana planu jest bezpłatna.",
      "Your access is blocked": "Dostęp został zablokowany",
      "Restore access": "Przywróć dostęp",
      "We could not start the payment. Please try again.": "Nie udało się rozpocząć płatności. Spróbuj ponownie.",
      "Trial ended": "Okres próbny zakończony",
      "Your subscription has expired": "Twoja subskrypcja wygasła",
      "Pay now": "Zapłać teraz",
      "Your trial ends in {{count}} days. Choose a plan to keep access.": "Okres próbny kończy się za {{count}} dni. Wybierz plan, aby zachować dostęp.",
      "We could not process your payment. Next attempt on {{date}}.": "Nie udało się pobrać płatności. Kolejna próba {{date}}.",
      "Your device count ({{count}}) exceeds the {{limit}} limit for the {{plan}} plan.": "Liczba urządzeń ({{count}}) przekracza limit {{limit}} planu {{plan}}.",
      // Subscription payment card
      "Payment card": "Karta płatnicza",
      "Card expires": "Karta ważna do",
      "No payment card on file": "Brak zapisanej karty płatniczej",
      "Add card": "Dodaj kartę",
      "Update card": "Zmień kartę",
      "Save card": "Zapisz kartę",
      "Save card and restore access": "Zapisz kartę i przywróć dostęp",
      "Card saved.": "Karta zapisana.",
      "Subscription fees are charged automatically to this card. You can replace it at any time.": "Opłaty za abonament pobierane są automatycznie z tej karty. Możesz ją zmienić w dowolnym momencie.",
      "Card data is entered directly into PayU and never reaches our servers.": "Dane karty wprowadzasz bezpośrednio w PayU — nie trafiają na nasze serwery.",
      "We authorise a small amount to verify the card and refund it immediately.": "W celu weryfikacji karty autoryzujemy niewielką kwotę i od razu ją zwracamy.",
      "Add a payment card to restore access. Future fees are charged to it automatically.": "Dodaj kartę płatniczą, aby przywrócić dostęp. Kolejne opłaty pobierzemy z niej automatycznie.",
      "Choose a plan and add a payment card to restore access. Future fees are charged to the card automatically.": "Wybierz plan i dodaj kartę płatniczą, aby przywrócić dostęp. Kolejne opłaty pobierzemy z karty automatycznie.",
      "Confirm and restore access": "Potwierdź i przywróć dostęp",
      "current plan": "obecny plan",
      "Add a payment card to finish restoring access.": "Dodaj kartę płatniczą, aby dokończyć przywracanie dostępu.",
      "Verifying your card… this can take a moment.": "Weryfikujemy Twoją kartę… to może chwilę potrwać.",
      "The payment form could not be loaded. Please try again.": "Nie udało się załadować formularza płatności. Spróbuj ponownie.",
      "The card details could not be verified. Check them and try again.": "Nie udało się zweryfikować danych karty. Sprawdź je i spróbuj ponownie.",
      "The card could not be saved. Please try a different card.": "Nie udało się zapisać karty. Spróbuj użyć innej karty.",
      "Your trial ends in {{count}} days. Add a payment card to keep access.": "Okres próbny kończy się za {{count}} dni. Dodaj kartę płatniczą, aby zachować dostęp.",
      // Subscription bank transfer
      "Pay by bank transfer": "Płać przelewem",
      "Pay by card": "Płać kartą",
      "Pay by bank transfer instead": "Zapłać przelewem",
      "Pay by card instead": "Zapłać kartą",
      "Card payments are currently unavailable.": "Płatności kartą są obecnie niedostępne.",
      "You now pay by bank transfer.": "Od teraz płacisz przelewem.",
      "You now pay by card.": "Od teraz płacisz kartą.",
      "Could not change the payment method. Please try again.": "Nie udało się zmienić formy płatności. Spróbuj ponownie.",
      "Subscription fee": "Opłata abonamentowa",
      "Plan upgrade surcharge": "Dopłata za zmianę planu",
      "Final settlement": "Rozliczenie końcowe",
      "Amount": "Kwota",
      "Transfer title": "Tytuł przelewu",
      "Due date": "Termin płatności",
      "Recipient": "Odbiorca",
      "Account number": "Numer konta",
      "Bank": "Bank",
      "Copied to clipboard": "Skopiowano do schowka",
      "Nothing to pay right now. We will e-mail the transfer details whenever a payment is due.": "Obecnie nie masz nic do zapłaty. Dane do przelewu wyślemy e-mailem, gdy pojawi się należność.",
      "Use the exact transfer title so we can match your payment. We send the invoice once the transfer is booked.": "Podaj dokładnie ten tytuł przelewu, abyśmy mogli przypisać wpłatę. Fakturę wyślemy po zaksięgowaniu przelewu.",
      "Transfer the amount below to restore access. We unlock the workspace as soon as we confirm the payment has arrived, usually within one business day.": "Aby przywrócić dostęp, przelej poniższą kwotę. Odblokujemy przestrzeń roboczą, gdy tylko potwierdzimy wpływ płatności — zwykle w ciągu jednego dnia roboczego.",
      "We have not received your transfer yet. Please pay the amount shown under Payment method.": "Nie odnotowaliśmy jeszcze Twojego przelewu. Opłać kwotę widoczną w sekcji Forma płatności.",
      "No charge during the trial. When it ends, transfer a prorated amount for the rest of that month, then the full plan fee each month, in advance.": "W okresie próbnym nie pobieramy opłat. Po jego zakończeniu przelej proporcjonalną kwotę za resztę miesiąca, a następnie pełną opłatę za plan co miesiąc, z góry.",
      "The plan fee is due in advance on the 1st of each calendar month; transfer it within {{days}} days using the title shown under Payment method. An upgrade is due immediately (prorated); a downgrade takes effect from the 1st of next month.": "Opłata za plan jest należna z góry 1. dnia każdego miesiąca kalendarzowego — przelej ją w ciągu {{days}} dni, podając tytuł widoczny w sekcji Forma płatności. Zmiana na wyższy plan jest płatna od razu (proporcjonalnie), a na niższy obowiązuje od 1. dnia kolejnego miesiąca.",
      // Subscription documents (proformas and invoices) and VAT exemption
      "Documents": "Dokumenty",
      "Document": "Dokument",
      "For": "Za",
      "No documents yet.": "Brak dokumentów.",
      "Could not load the documents.": "Nie udało się wczytać dokumentów.",
      "Could not download the document. Please try again.": "Nie udało się pobrać dokumentu. Spróbuj ponownie.",
      "Download proforma {{number}}": "Pobierz fakturę proforma {{number}}",
      "exempt": "zw.",
      "Seller is exempt from VAT ({{basis}}).": "Sprzedawca zwolniony z VAT ({{basis}}).",
      "Seller is exempt from VAT – prices are final.": "Sprzedawca zwolniony z VAT – podane ceny są cenami końcowymi.",
      // Subscription self-serve cancellation
      "Cancel subscription": "Anuluj abonament",
      "Keep subscription": "Zachowaj abonament",
      "Confirm cancellation": "Potwierdź anulowanie",
      "Abort cancellation": "Cofnij anulowanie",
      "Your subscription is scheduled to end on {{date}}. You keep full access until then.": "Abonament zakończy się {{date}}. Do tego czasu zachowujesz pełny dostęp.",
      "The plan stays fully usable until {{date}}, the end of the current paid period. After that the workspace is locked until a new plan is chosen. No further charges are made.": "Plan pozostaje w pełni aktywny do {{date}}, czyli do końca bieżącego opłaconego okresu. Później przestrzeń robocza zostanie zablokowana do czasu wybrania nowego planu. Nie pobieramy kolejnych opłat.",
      "Subscription cancellation scheduled.": "Zaplanowano anulowanie abonamentu.",
      "Cancellation aborted. Your subscription continues.": "Anulowanie cofnięte. Abonament jest kontynuowany.",
      "Could not cancel the subscription. Please try again.": "Nie udało się anulować abonamentu. Spróbuj ponownie.",
      "Could not abort the cancellation. Please try again.": "Nie udało się cofnąć anulowania. Spróbuj ponownie.",
      "Scheduled termination date": "Planowane usunięcie",
      "Not scheduled": "Nie zaplanowano",
      "Current state": "Aktualny stan",
      "Deactivate workspace": "Dezaktywuj przestrzeń roboczą",
      "Undo deactivation": "Cofnij dezaktywację",
      "Processing...": "Przetwarzanie...",
      "Confirm deactivation": "Potwierdź dezaktywację",
      "Confirm undo deactivation": "Potwierdź cofnięcie dezaktywacji",
      "Deactivating the workspace will schedule its termination. You will retain access until the termination date.": "Dezaktywacja przestrzeni roboczej spowoduje zaplanowanie jej usunięcia. Dostęp pozostanie aktywny do daty usunięcia.",
      "Undoing the workspace deactivation will cancel the scheduled termination.": "Cofnięcie dezaktywacji przestrzeni roboczej spowoduje anulowanie zaplanowanego usunięcia.",
      "Workspace deactivated successfully": "Przestrzeń robocza została dezaktywowana pomyślnie",
      "Workspace deactivation failed": "Dezaktywacja przestrzeni roboczej nie powiodła się",
      "Workspace deactivation undone successfully": "Cofnięcie dezaktywacji przestrzeni roboczej powiodło się",
      "Workspace deactivation undo failed": "Cofnięcie dezaktywacji przestrzeni roboczej nie powiodło się",
      "Inactive": "Nieaktywny",
      "Net price": "Cena netto",
      "Add user": "Dodaj użytkownika",
      "User added successfully": "Użytkownik został dodany pomyślnie",
      "User add failed": "Dodanie użytkownika nie powiodło się",
      "Basic Information": "Informacje podstawowe",
      "User Details": "Dane użytkownika",
      "Edit user": "Edytuj użytkownika",
      "Remove user": "Usuń użytkownika",
      "User removed from workspace successfully": "Użytkownik został usunięty z przestrzeni roboczej pomyślnie",
      "Failed to remove user from workspace": "Usuwanie użytkownika z przestrzeni roboczej nie powiodło się",
      "Are you sure you want to remove this user from the workspace?": "Czy jesteś pewny, że chcesz usunąć tego użytkownika z przestrzeni roboczej?",
      "User": "Użytkownik",
      "Removing this user from the workspace will revoke their access. They will no longer be able to access this workspace.": "Usunięcie tego użytkownika z przestrzeni roboczej spowoduje odwołanie jego dostępu. Nie będzie mógł już korzystać z tej przestrzeni roboczej.",
      "This action cannot be undone. The user will need to be re-invited to regain access.": "Ta akcja nie może zostać cofnięta. Użytkownik będzie musiał zostać zaproszony ponownie, aby uzyskać dostęp.",
      "Confirm removal": "Potwierdź usunięcie",
      "Confirm": "Potwierdź",
      "Preview": "Podgląd",
      "Open full view": "Otwórz pełny widok",
      "Remove from workspace": "Usuń z przestrzeni roboczej",
      "How do you want to remove this user from the workspace?": "Jak chcesz usunąć tego użytkownika z przestrzeni roboczej?",
      "Remove from workspace (recommended) — Revoke access only. The user remains in the workspace database and can be re-activated later.": "Usuń z przestrzeni roboczej (zalecane) — Tylko odwołaj dostęp. Użytkownik pozostaje w bazie przestrzeni roboczej i może zostać ponownie aktywowany.",
      "Permanently delete user — Remove the user from the workspace and delete their account from the database. This cannot be undone.": "Trwale usuń użytkownika — Usuń użytkownika z przestrzeni roboczej i usuń jego konto z bazy danych. Tej operacji nie można cofnąć.",
      "User permanently deleted": "Użytkownik został trwale usunięty",
      "Status": "Status",
      "Re-activate user": "Ponownie aktywuj użytkownika",
      "User re-activated successfully": "Użytkownik został ponownie aktywowany pomyślnie",
      "Failed to re-activate user": "Ponowne aktywowanie użytkownika nie powiodło się",
      "This action cannot be undone. The group will need to be re-created to regain access.": "Ta akcja nie może zostać cofnięta. Grupa będzie musiała zostać utworzona ponownie, aby uzyskać dostęp.",
      // common
      "Name": "Nazwa",
      "Address": "Adres",
      "No data": "Brak danych",
      "Rows per page": "Wierszy na stronę",
      "Sort by": "Sortuj według",
      "No sorting": "Bez sortowania",
      "Direction": "Kierunek",
      "Columns": "Kolumny",
      "Search": "Szukaj",
      "Grid profile": "Profil siatki",
      "Unsaved": "Niezapisany",
      "Add profile": "Dodaj profil",
      "Save profile": "Zapisz profil",
      "Create profile": "Utwórz profil",
      "Imported profile": "Profil importowany",
      "Set as default": "Ustaw jako domyślny",
      "Default": "Domyślny",
      "Profile name": "Nazwa profilu",
      "Save grid profile": "Zapisz profil siatki",
      "Create grid profile": "Utwórz profil siatki",
      "Profile saved": "Profil został zapisany",
      "Profile created": "Profil został utworzony",
      "Profile updated": "Profil został zaktualizowany",
      "Remove profile": "Usuń profil",
      "Profile removed": "Profil został usunięty",
      "Default profile updated": "Domyślny profil został zaktualizowany",
      "Profile name is required": "Nazwa profilu jest wymagana",
      "Toolbar shortcut": "Skrót paska akcji",
      "Choose shortcut": "Wybierz skrót",
      "Set shortcut": "Ustaw skrót",
      "Change shortcut": "Zmień skrót",
      "Choose one shortcut action": "Wybierz jedną akcję skrótu",
      "Pick one action that should be available from the bottom shortcut.": "Wybierz jedną akcję, która ma być dostępna z dolnego skrótu.",
      "Available on this page": "Dostępne na tej stronie",
      "Will open on its target page": "Otworzy się na docelowej stronie",
      "You can change this shortcut anytime.": "Możesz zmienić ten skrót w dowolnym momencie.",
      "Shortcut updated": "Skrót został zaktualizowany",
      "Shortcut update failed": "Aktualizacja skrótu nie powiodła się",
      "Unavailable": "Niedostępne",
      "Unavailable here": "Niedostępne tutaj",
      "Shortcut unavailable": "Skrót jest niedostępny",
      "Has pending settlement": "Oczekujące rozliczenie",
      "Equipment quantity": "Liczba urządzeń",
      "Clients list": "Lista klientów",
      "Add new client": "Dodaj klienta",
      "Delete client": "Usuń klienta",
      "Update client": "Zaktualizuj dane klienta",
      "Client deleted successfully": "Klient został usunięty pomyślnie",
      "Failed to delete client": "Usuwanie klienta nie powiodło się",
      "Deleting this client will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego klienta spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "This action cannot be undone. All associated data will be permanently deleted.": "Ta akcja nie może zostać cofnięta. Wszystkie powiązane dane zostaną trwale usunięte.",
      "Confirm deletion": "Potwierdź usunięcie",
      "Website": "Strona internetowa",
      "Logo": "Logo",
      "Edit workspace": "Edytuj przestrzeń roboczą",
      "Workspace information": "Informacje o przestrzeni roboczej",
      "Trial": "Okres próbny",
      "Active": "Aktywne",
      "Expired": "Wygasły",
      "Users": "Użytkownicy",
      "Online users": "Użytkownicy online",
      "No users are online right now.": "Aktualnie żaden użytkownik nie jest online.",
      "Last activity": "Ostatnia aktywność",
      "Failed to fetch online users": "Nie udało się pobrać użytkowników online",
      "Groups": "Grupy",
      "First Name": "Imię",
      "Last Name": "Nazwisko",
      "Add": "Dodaj",
      "Submit": "Zatwierdź",
      "No options": "Brak opcji",
      "Loading...": "Ładowanie...",
      "There was an error, please review the form.": "Wystąpił błąd, sprawdź formularz ponownie.",
      "This model already exists for this producer.": "Ten model już istnieje dla tego Producenta.",
      "An unexpected error occurred": "Wystąpił nieoczekiwany błąd",
      "Form was succesfully processed.": "Formularz został pomyślnie przetworzony.",
      // Client details
      "Individual": "Osoba fizyczna",
      "Legal": "Osoba prawna",
      "Legal Entity": "Osoba prawna",
      "Type": "Typ",
      "Identification Numbers": "Numery identyfikacyjne",
      "Address Information": "Informacje adresowe",
      "Street": "Ulica",
      "City": "Miasto",
      "Zip Code": "Kod pocztowy",
      "Country": "Kraj",
      "View on Google Maps": "Zobacz w Google Maps",
      "Contact Information": "Informacje kontaktowe",
      "Phone Number": "Numer telefonu",
      "Email": "E-mail",
      "Invoices Email": "E-mail do faktur",
      "Additional Information": "Informacje dodatkowe",
      "Notes": "Notatki",
      "Opening Hours": "Godziny otwarcia",
      "Opening hours": "Godziny otwarcia",
      "No opening hours": "Brak godzin otwarcia",
      "Week day": "Dzień tygodnia",
      "From": "Od",
      "To": "Do",
      "Zip code": "Kod pocztowy",
      "Phone number": "Numer telefonu",
      "Email for invoices": "E-mail do faktur",
      "Email for counter reminders": "E-mail do przypomnień liczników",
      "Poland": "Polska",
      "Fetch the data": "Uzupełnij dane",
      "Fetching...": "Pobieranie...",
      "Enter NIP to load company data": "Wprowadź NIP, aby wczytać dane firmy",
      "Company not found for this NIP.": "Nie znaleziono firmy dla podanego NIP.",
      "Company data loaded.": "Dane firmy zostały uzupełnione.",
      "Please enter NIP": "Proszę wprowadzić NIP",
      "Failed to verify NIP.": "Weryfikacja NIP nie powiodła się.",
      "NIP": "NIP",
      "REGON": "REGON",
      "KRS": "KRS",
      "PESEL": "PESEL",
      "Working days (Mon-Fri)": "Dni robocze (pn-pt)",
      "Monday": "Poniedziałek",
      "Tuesday": "Wtorek",
      "Wednesday": "Środa",
      "Thursday": "Czwartek",
      "Friday": "Piątek",
      "Saturday": "Sobota",
      "Sunday": "Niedziela",
      "Metadata": "Metadane",
      "Created At": "Utworzono",
      "Updated At": "Zaktualizowano",

      // Equipment
      "Equipment": "Urządzenie",
      "Equipment section": "Sprzęt",
      "Equipment-section": "Sprzęt",
      "Equipments": "Urządzenia",
      "Configurations": "Konfiguracje",
      "Configuration": "Konfiguracja",
      "Devices": "Urządzenia",
      "Add new equipment": "Dodaj urządzenie",
      "Update equipment": "Zaktualizuj urządzenie",
      "Delete equipment": "Usuń urządzenie",
      "Equipment deleted successfully": "Urządzenie zostało usunięte pomyślnie",
      "Failed to delete equipment": "Usuwanie urządzenia nie powiodło się",
      "Deleting this equipment will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego urządzenia spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      // Equipment archiving
      "Archive equipment": "Zarchiwizuj urządzenie",
      "Restore equipment": "Przywróć urządzenie",
      "Archived": "Zarchiwizowane",
      "Archived at": "Zarchiwizowano",
      "Archived equipment": "Zarchiwizowane urządzenia",
      "Confirm archiving": "Potwierdź archiwizację",
      "Confirm restoring": "Potwierdź przywrócenie",
      "Equipment archived successfully": "Urządzenie zostało zarchiwizowane",
      "Equipment restored successfully": "Urządzenie zostało przywrócone",
      "Failed to archive equipment": "Archiwizacja urządzenia nie powiodła się",
      "Failed to restore equipment": "Przywracanie urządzenia nie powiodło się",
      "Archived equipment does not count towards the subscription plan's device limit.": "Zarchiwizowane urządzenie nie wlicza się do limitu urządzeń planu abonamentowego.",
      "Archived equipment no longer counts towards your subscription plan's device limit and is not offered when picking equipment. Its history is kept - you will find it under the Archived filter of the equipment list and can restore it at any time.": "Zarchiwizowane urządzenie przestaje wliczać się do limitu urządzeń planu abonamentowego i nie jest proponowane przy wyborze urządzeń. Jego historia zostaje zachowana — znajdziesz je pod filtrem „Zarchiwizowane” na liście urządzeń i w każdej chwili możesz je przywrócić.",
      "Restored equipment counts towards your subscription plan's device limit again and can be picked for contracts and jobs.": "Przywrócone urządzenie ponownie wlicza się do limitu urządzeń planu abonamentowego i można je wybierać w umowach i zleceniach.",
      "Description": "Opis",
      "Serial Number": "Numer seryjny",
      "Model": "Model",
      "Producer": "Producent",
      "Add new model": "Dodaj nowy model",
      "Add new producer": "Dodaj nowego producenta",
      "Add configuration": "Dodaj konfigurację",
      "Edit configuration": "Edytuj konfigurację",
      "Delete configuration": "Usuń konfigurację",
      "Configuration created successfully": "Konfiguracja została utworzona pomyślnie",
      "Configuration updated successfully": "Konfiguracja została zaktualizowana pomyślnie",
      "Configuration deleted successfully": "Konfiguracja została usunięta pomyślnie",
      "Failed to delete configuration": "Usuwanie konfiguracji nie powiodło się",
      "No configurations available": "Brak dostępnych konfiguracji",
      "Option": "Opcja",
      "Choose option": "Wybierz opcję",
      "Options": "Opcje",
      "Choice": "Wybór",
      "Choices": "Wybory",
      "Choice name": "Nazwa wyboru",
      "No choices": "Brak wyborów",
      "Note": "Notatka",
      "Other": "Inne",
      "Type and press Enter or Add": "Wpisz i naciśnij Enter lub Dodaj",
      "Deleting this configuration will permanently remove it from the system. This action cannot be undone.": "Usunięcie tej konfiguracji spowoduje trwałe usunięcie jej z systemu. Ta akcja nie może zostać cofnięta.",
      "Technical Details": "Szczegóły techniczne",
      "Equipments Serials": "Numery seryjne urządzeń",
      "Valid counters": "Ważne liczniki",

      // Equipment Producers
      "Add producer": "Dodaj producenta",
      "Edit producer": "Edytuj producenta",
      "Delete producer": "Usuń producenta",
      "Models": "Modele",
      "Assigned Models": "Przypisane modele",
      "Producer created successfully": "Producent został utworzony pomyślnie",
      "Producer updated successfully": "Producent został zaktualizowany pomyślnie",
      "Producer deleted successfully": "Producent został usunięty pomyślnie",
      "Failed to delete producer": "Usuwanie producenta nie powiodło się",
      "Model name": "Nazwa modelu",
      "No models assigned": "Brak przypisanych modeli",
      "No metadata available": "Brak dostępnych metadanych",
      "Deleting this producer will remove it and unassign its models. This action cannot be undone.": "Usunięcie tego producenta spowoduje jego usunięcie oraz odłączenie modeli. Tej akcji nie można cofnąć.",
      "Request failed": "Żądanie nie powiodło się",

      // Contracts
      "Contracts list": "Lista umów",
      "Add new contract": "Dodaj umowę",
      "Update contract": "Zaktualizuj umowę",
      "Delete contract": "Usuń umowę",
      "Contract deleted successfully": "Umowa została usunięta pomyślnie",
      "Failed to delete contract": "Usuwanie umowy nie powiodło się",
      "Deleting this contract will permanently remove it from the system. This action cannot be undone.": "Usunięcie tej umowy spowoduje trwałe usunięcie jej z systemu. Ta akcja nie może zostać cofnięta.",
      "Revoke end of contract": "Cofnij zakończenie umowy",
      "Are you sure you want to make this contract active again? Please set a new end date for the contract.": "Czy na pewno chcesz ponownie aktywować tę umowę? Ustaw nową datę zakończenia umowy.",
      "New end date": "Nowa data zakończenia",
      "Contract end revoked successfully": "Zakończenie umowy zostało cofnięte pomyślnie",
      "Failed to revoke contract end": "Cofnięcie zakończenia umowy nie powiodło się",
      "1 month": "1 miesiąc",
      "6 months": "6 miesięcy",
      "1 year": "1 rok",
      "Indefinitely": "Bezterminowo",
      "Start Date": "Data rozpoczęcia",
      "End Date": "Data zakończenia",
      "Expired contracts": "Wygasłe umowy",
      "Failed to fetch expired contracts": "Pobieranie wygasłych umów nie powiodło się",
      "Choose what to do with each expired contract": "Wybierz działanie dla każdej wygasłej umowy",
      "No expired contracts to process.": "Brak wygasłych umów do przetworzenia.",
      "No number": "Brak numeru",
      "Make indefinite": "Ustaw bezterminowo",
      "End contract": "Zakończ umowę",
      "Please choose action for at least one contract": "Wybierz działanie dla co najmniej jednej umowy",
      "Expired contracts processed successfully": "Wygasłe umowy zostały pomyślnie przetworzone",
      "Failed to process expired contracts": "Przetwarzanie wygasłych umów nie powiodło się",
      "Submit ({{count}} selected)": "Zatwierdź (wybrano: {{count}})",
      "Indefinite": "Bezterminowa",
      "Continues indefinitely after this date": "Trwa bezterminowo po tej dacie",
      "Ended": "Zakończone",
      "Email service status": "Status usługi e-mail",
      "History of counters ingestion": "Historia pobierania liczników",
      "Failed to fetch history of counters ingestion": "Pobieranie historii liczników nie powiodło się",
      "No history of counters ingestion available.": "Brak dostępnej historii pobierania liczników.",
      "Run ingestion": "Uruchom pobieranie",
      "Starting ingestion...": "Uruchamianie pobierania...",
      "Refresh history": "Odśwież historię",
      "Counters ingestion has started. It runs in the background — refresh the history in a moment to see the result.": "Pobieranie liczników zostało uruchomione. Działa w tle — odśwież historię za chwilę, aby zobaczyć wynik.",
      "Failed to start counters ingestion": "Uruchomienie pobierania liczników nie powiodło się",
      "With errors": "Z błędami",
      "Success": "Sukces",
      "Fetched": "Pobrano",
      "Parsed": "Przetworzono",
      "Counters created": "Utworzone liczniki",
      "From PDFs": "Z PDF",
      "From counter reports": "Z raportów licznika",
      "Errors": "Błędy",
      "Show errors ({{count}})": "Pokaż błędy ({{count}})",
      "Hide errors": "Ukryj błędy",

      // Permission roles
      "Permission Roles": "Role uprawnień",
      "Permission Role Details": "Szczegóły roli uprawnień",
      // Permission groups
      "Permission Groups": "Grupy uprawnień",
      "Permission-groups": "Grupy uprawnień",
      "Select All": "Zaznacz wszystkie",
      "Select permission groups": "Wybierz grupy uprawnień",
      "Permissions": "Uprawnienia",
      "No permissions assigned": "Brak przypisanych uprawnień",
      "Name is required": "Nazwa jest wymagana",
      "Select Permissions": "Wybierz uprawnienia",
      "Loading permissions...": "Ładowanie uprawnień...",
      "Update Permission Group": "Zaktualizuj grupę uprawnień",
      "Create Permission Group": "Utwórz grupę uprawnień",
      "Permission group updated successfully": "Grupa uprawnień została zaktualizowana pomyślnie",
      "Permission group update failed": "Aktualizacja grupy uprawnień nie powiodła się",
      "Permission group created successfully": "Grupa uprawnień została utworzona pomyślnie",
      "Permission group creation failed": "Utworzenie grupy uprawnień nie powiodło się",
      "Add permission group": "Dodaj grupę uprawnień",
      "Edit permission group": "Edytuj grupę uprawnień",
      "Delete permission group": "Usuń grupę uprawnień",
      "Are you sure you want to delete the permission group": "Czy jesteś pewny, że chcesz usunąć grupę uprawnień",
      "Delete": "Usuń",
      "Permission group deleted successfully": "Grupa uprawnień została usunięta pomyślnie",
      "Permission group deletion failed": "Usunięcie grupy uprawnień nie powiodło się",
      "User updated successfully": "Użytkownik został zaktualizowany pomyślnie",
      "User update failed": "Aktualizacja użytkownika nie powiodła się",
      "Update user": "Zaktualizuj użytkownika",
      "You cannot modify your own permission groups": "Nie możesz modyfikować własnych grup uprawnień",
      "Remove user from workspace": "Usuń użytkownika z przestrzeni roboczej",
      "Contracts": "Umowy",
      "Contract": "Umowa",
      "Contract details": "Szczegóły umowy",
      "Signature Date": "Data podpisu",
      "Number": "Numer",
      "Internal name": "Nazwa wewnętrzna",
      "Client Name": "Nazwa klienta",
      "Issuance Date": "Data wydania",
      "Is Signed": "Jest podpisane",
      "Settlements": "Rozliczenia",
      "Settlements Summary": "Podsumowanie rozliczeń",
      "Monthly sale summary": "Miesięczne podsumowanie sprzedaży",
      "Net Total": "Suma netto",
      "Month": "Miesiąc",
      "Consider counter value as outdated after days": "Uznaj wartość licznika jako nieaktualną po dniach",
      "Update settings": "Zaktualizuj ustawienia",
      "Saving...": "Zapisywanie...",
      "Settings updated successfully": "Ustawienia zaktualizowane pomyślnie",
      "Settings update failed": "Aktualizacja ustawień nie powiodła się",
      "Settings": "Ustawienia",
      "Edit settings": "Edytuj ustawienia",
      "Email server configuration": "Konfiguracja serwera e-mail",
      "Counters configuration": "Konfiguracja liczników",
      "Reminders configuration": "Konfiguracja przypomnień",
      "SMTP server": "Serwer SMTP",
      "SMTP port": "Port SMTP",
      "SMTP username": "Nazwa użytkownika SMTP",
      "SMTP password": "Hasło SMTP",
      "IMAP server": "Serwer IMAP",
      "IMAP port": "Port IMAP",
      "IMAP username": "Nazwa użytkownika IMAP",
      "IMAP password": "Hasło IMAP",
      "Hide": "Ukryj",
      "Reveal": "Pokaż",
      "Clients": "Klienci",
      "Tenant": "Przestrzeń robocza",
      "Year": "Rok",
      "Contract Number": "Numer umowy",
      "Equipment Name": "Nazwa urządzenia",
      "Confirmed at": "Potwierdzono dnia",
      "Settlements for": "Rozliczenia dotyczące",
      "January": "Styczeń",
      "February": "Luty",
      "March": "Marzec",
      "April": "Kwiecień",
      "May": "Maj",
      "June": "Czerwiec",
      "July": "Lipiec",
      "August": "Sierpień",
      "September": "Wrzesień",
      "October": "Październik",
      "November": "Listopad",
      "December": "Grudzień",
      "Sale date": "Data sprzedaży",
      "Clear": "Wyczyść",
      "Kind": "Rodzaj",
      "Ownership": "Własność",
      "Installation address": "Adres instalacji",
      "Mark as returned to {{tenant}}": "Oznacz jako zwrócone do {{tenant}}",
      "Is installed": "Zainstalowany",
      "Serial": "Numer seryjny",
      "Code": "Kod",
      "Color": "Kolor",
      "Black and white": "Czarno-białe",
      "Own": "Własne",
      "Leasing": "Leasing",
      "Client's": "Klienta",
      "Provider": "Dostawca",
      "Active equipment": "Aktywne urządzenia",
      "Previously used equipment": "Poprzednio używane urządzenia",
      "Contract Start Date": "Początek umowy",
      "Contract End Date": "Koniec umowy",
      "Installation Address": "Adres instalacji",
      "Pages in package": "Strony w pakiecie",
      "Assigned Contracts": "Przypisane umowy",
      "Assigned-contracts": "Przypisane umowy",
      "Service History": "Historia serwisu",
      "Service Stats": "Statystyki serwisu",
      "Equipment-stats": "Statystyki urządzenia",
      "Group-stats": "Statystyki grupy",
      "Equipment-groups": "Grupy urządzeń",
      "Most Common Technician": "Najczęściej przypisany technik",
      "Most Common Technicians": "Najczęściej przypisywani technicy",
      "Assigned Jobs": "Przypisane zlecenia",
      "Last 3 Months": "Ostatnie 3 miesiące",
      "Last 6 Months": "Ostatnie 6 miesięcy",
      "Last 12 Months": "Ostatnie 12 miesięcy",
      "Total Jobs": "Wszystkie zlecenia",
      "Jobs in Selected Period": "Zlecenia w wybranym okresie",
      "Recent Jobs": "Ostatnie zlecenia",
      "No technician assignments yet": "Brak przypisań techników",
      "No recent jobs for this equipment": "Brak ostatnich zleceń dla tego urządzenia",
      "Statistics": "Statystyki",
      "General Stats": "Statystyki ogólne",
      "General-stats": "Statystyki ogólne",
      "General Statistics": "Statystyki ogólne",
      "Equipment by Parts Cost": "Urządzenia wg kosztu części",
      "Top Used Parts": "Najczęściej używane części",
      "Most Visited Equipment": "Najczęściej obsługiwane urządzenia",
      "Top Job Issues": "Najpopularniejsze usterki",
      "Top Job Services": "Najpopularniejsze usługi",
      "Top Equipment": "Najczęściej zużywające urządzenia",
      "Parts Value (zł)": "Wartość części (zł)",
      "Parts Quantity": "Ilość części",
      "Equipment Groups": "Grupy urządzeń",
      "Equipment Group": "Grupa urządzeń",
      "Technicians": "Technicy",
      "Technician": "Technik",
      "Equipment Stats": "Statystyki urządzenia",
      "Group Stats": "Statystyki grupy",
      "Add new group": "Dodaj nową grupę",
      "Update group": "Edytuj grupę",
      "Delete group": "Usuń grupę",
      "Group deleted successfully": "Grupa została usunięta",
      "Failed to delete group": "Nie udało się usunąć grupy",
      "Deleting this group will permanently remove it. Equipments themselves will not be affected.": "Usunięcie tej grupy jest nieodwracalne. Same urządzenia nie zostaną usunięte.",
      "Equipment Models": "Modele urządzeń",
      "Assigned Equipment Models": "Przypisane modele urządzeń",
      "No equipment models assigned to this group yet": "Brak modeli urządzeń przypisanych do tej grupy",
      "Job Issues": "Usterki",
      "Job Services": "Usługi",
      "Issue": "Usterka",
      "Count": "Ilość",
      "No job issues recorded yet": "Brak zarejestrowanych usterek",
      "No job services recorded yet": "Brak zarejestrowanych usług",
      "Most Common Equipment": "Najczęściej naprawiane urządzenia",
      "No equipment history yet": "Brak historii urządzeń",
      "History of Jobs": "Historia zleceń",
      "No jobs assigned yet": "Brak przypisanych zleceń",
      "Complaints": "Reklamacje",
      "Complaints Handled": "Obsłużone reklamacje",
      "Complaints Received": "Otrzymane reklamacje",
      "Quantity / Value": "Ilość / Wartość",
      "No parts used on this equipment yet": "Brak użytych części dla tego urządzenia",
      "No parts used for this group yet": "Brak użytych części dla tej grupy",
      "Select an equipment to see its statistics": "Wybierz urządzenie, aby zobaczyć jego statystyki",
      "Select an equipment group to see its statistics": "Wybierz grupę urządzeń, aby zobaczyć jej statystyki",
      "All Time": "Cały okres",
      "Created": "Utworzono",
      "Created By": "Utworzone przez",
      "Created by": "Utworzone przez",
      "Assigned To": "Przypisane do",
      "Finished At": "Ukończone dnia",
      "Status Changed At": "Data zmiany statusu",
      // Job page: time spent in each status
      "Time in statuses": "Czas w statusach",
      "The job has not been started yet, or its status changes were not recorded.":
        "Zlecenie nie zostało jeszcze rozpoczęte lub zmiany jego statusu nie zostały zapisane.",
      "Until sent for verification": "Do przekazania do weryfikacji",
      "{{value}} times": "{{value}} razy",
      "ongoing": "w toku",
      "now": "teraz",
      "Status timeline": "Oś czasu statusów",
      "Duration": "Czas trwania",
      "< 1 min": "< 1 min",
      "{{value}} d": "{{value}} d.",
      "{{value}} h": "{{value}} godz.",
      "{{value}} min": "{{value}} min",
      "Services Count": "Liczba usług",
      "Counters": "Liczniki",
      "Add new counter": "Dodaj nowy licznik",
      "Add used part": "Dodaj zużyty element",
      "Change installation address": "Zmień adres instalacji",
      "This job has multiple equipments. Select which one's installation address to change.": "To zlecenie ma przypisanych kilka urządzeń. Wybierz, którego adres instalacji chcesz zmienić.",
      "Value": "Wartość",
      "Value (zł)": "Wartość (zł)",
      "Services Value (zł)": "Wartość usług (zł)",
      "Pages printed plus the jobs finished in the period - each job at the prices of its services, or at the mean job cost when none is priced.":
        "Wydrukowane strony oraz zlecenia zakończone w okresie - każde zlecenie według cen jego usług albo według średniego kosztu zlecenia, gdy żadna nie ma ceny.",
      "Read at": "Odczytane dnia",
      "Provided by": "Dostarczone przez",
      "Confirm counter value": "Potwierdź wartość licznika",
      "Are you sure you want to enter a counter value lower than the latest recorded value?": "Czy na pewno chcesz wprowadzić wartość licznika niższą od ostatniej zarejestrowanej?",
      "Entered value": "Wprowadzona wartość",
      "Latest value": "Ostatnia wartość",
      "Cancel": "Anuluj",
      "Settlement Cycle": "Cykl rozliczeniowy",
      "Settlement kind": "Typ rozliczenia",
      "Has pending settlements": "Oczekujące rozliczenia",
      "Settled": "Rozliczona",
      "Unsettled": "Nierozliczona",
      "Actions": "Akcje",
      "First Settlement Date": "Data pierwszego rozliczenia",
      "Next Settlement Date": "Data następnego rozliczenia",
      "Delete counter": "Usuń licznik",
      "Counter deleted successfully": "Licznik został usunięty pomyślnie",
      "Failed to delete counter": "Usuwanie licznika nie powiodło się",
      "Deleting this counter will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego licznika spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "Update counter": "Zaktualizuj licznik",
      "Name and surname": "Imię i nazwisko",
      "Black pages": "Czarne strony",
      "Color pages": "Kolorowe strony",
      "Scanned pages": "Skanowane strony",
      "No counters recorded for this equipment yet.": "Dla tego urządzenia nie zarejestrowano jeszcze żadnych liczników.",
      "Black pages limit": "Limit czarnych stron",
      "Color pages limit": "Limit kolorowych stron",
      "Black pages over limit": "Czarne strony ponad limit",
      "Color pages over limit": "Kolorowe strony ponad limit",
      "Add scanned pages": "Dodaj skanowane strony",
      "Automatic email": "Automatyczny e-mail",
      "Home": "Strona główna",
      "Service": "Serwis",
      "Job Kind": "Rodzaj zlecenia",
      "Service Code": "Usługa",
      "Service Codes": "Usługi",
      "Job Service Code": "Usługa",
      "Job Service Codes": "Usługi",
      "Stock Status": "Stan magazynu",
      "Jobs": "Zlecenia",
      "Job": "Zlecenie",
      "Job Information": "Informacje o zleceniu",
      "Job Details": "Szczegóły zlecenia",
      "Job History": "Historia zlecenia",
      "Used parts": "Zużyte elementy",
      "Ordered part": "Zamówienie",
      "Messages": "Wiadomości",
      "Notifications": "Powiadomienia",
      "No notifications yet": "Brak powiadomień",
      "Notification settings": "Ustawienia powiadomień",
      "Choose which notification types you want to receive.": "Wybierz, które typy powiadomień chcesz otrzymywać.",
      "Job status changes": "Zmiany statusu zleceń",
      "Notify me when a job status changes.": "Powiadamiaj mnie, gdy zmieni się status zlecenia.",
      "Mail ingestion alerts": "Alerty importu poczty",
      "Notify me when mail ingestion adds counters.": "Powiadamiaj mnie, gdy import poczty doda liczniki.",
      "Low stock alerts": "Alerty niskiego stanu magazynu",
      "Notify me when a part reaches its notification threshold.": "Powiadamiaj mnie, gdy produkt osiągnie swój próg powiadomienia.",
      "You can change these preferences anytime.": "Możesz zmienić te preferencje w dowolnym momencie.",
      "Author": "Autor",
      "All authors": "Wszyscy autorzy",
      "Search messages": "Szukaj wiadomości",
      "No messages yet. Start the conversation below.": "Brak wiadomości. Rozpocznij rozmowę poniżej.",
      "No messages yet. Write your first message using the form on the right.": "Brak wiadomości. Napisz pierwszą wiadomość w formularzu po prawej stronie.",
      "New message": "Nowa wiadomość",
      "You do not have permission to send messages.": "Nie masz uprawnień do wysyłania wiadomości.",
      "Open in new tab": "Otwórz w nowej karcie",
      "Close": "Zamknij",
      "Unread": "Nieprzeczytane",
      "Edit message": "Edytuj wiadomość",
      "Delete message": "Usuń wiadomość",
      "Message updated": "Wiadomość zaktualizowana",
      "Failed to update message": "Nie udało się zaktualizować wiadomości",
      "Message deleted": "Wiadomość usunięta",
      "Failed to delete message": "Nie udało się usunąć wiadomości",
      "Save": "Zapisz",
      "Write a message": "Napisz wiadomość",
      "Send": "Wyślij",
      "Message sent": "Wiadomość wysłana",
      "Failed to send message": "Nie udało się wysłać wiadomości",
      "Failed to load messages": "Nie udało się załadować wiadomości",
      "Failed to upload attachment": "Nie udało się wgrać załącznika",
      "You do not have permission to view messages.": "Nie masz uprawnień do przeglądania wiadomości.",
      "No equipment assigned to this job.": "Brak urządzeń przypisanych do tego zlecenia.",
      "Contract History": "Historia umowy",
      "Changed by": "Zmienione przez",
      "System": "System",
      "No field changes detected": "Nie wykryto zmian pól",
      "Root": "Główna",
      "Terms": "Warunki",
      "No history records available": "Brak wpisów historii",
      "Failed to load history": "Nie udało się załadować historii",
      "Load more": "Załaduj więcej",
      "Added": "Dodano",
      "Removed": "Usunięto",
      "Updated": "Zaktualizowano",
      "From value": "Z",
      "To value": "Na",
      "Empty": "Puste",
      "Job Created By": "Utworzone przez",
      "Job Assigned To": "Przypisane do",
      "Job Finished At": "Ukończone dnia",
      "Job Services Count": "Liczba usług",
      "History": "Historia serwisu",
      "New job": "Nowe zlecenie",
      "Update job": "Zaktualizuj zlecenie",
      "Complain job": "Zareklamuj zlecenie",
      "Delete job": "Usuń zlecenie",
      "Job deleted successfully": "Zlecenie zostało usunięte pomyślnie",
      "Failed to delete job": "Usuwanie zlecenia nie powiodło się",
      "Job status updated successfully": "Status zlecenia został zaktualizowany pomyślnie",
      "Failed to update job status": "Aktualizacja statusu zlecenia nie powiodła się",
      "Additional actions required": "Wymagane dodatkowe działania",
      "Please confirm the following actions before proceeding with the status change.": "Przed zmianą statusu potwierdź poniższe działania.",
      "Fill in the fields below, then save your progress or confirm to change the job status.":
        "Wypełnij poniższe pola, a następnie zapisz postęp lub potwierdź zmianę statusu zlecenia.",
      "Accept all & change status": "Zatwierdź wszystko i zmień status",
      "Progress saved successfully": "Postęp został zapisany",
      "Failed to save changes": "Nie udało się zapisać zmian",
      "Obligatory": "Obowiązkowe",
      "Optional": "Opcjonalne",
      "No equipment": "Brak urządzenia",
      "Change status": "Zmień status",
      "Deleting this job will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego zlecenia spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "Complaint For": "Reklamacja do",
      "Complaint for": "Reklamacja do",
      "Issues": "Usterki",
      "Issues / Services": "Usterki / Usługi",
      "Tasks": "Zadania",
      "Task": "Zadanie",
      "Update tasks": "Zaktualizuj zadania",
      "Add task": "Dodaj zadanie",
      "Task description": "Opis zadania",
      "Task finished at": "Zadanie ukończono dnia",
      "Add new service code": "Dodaj nową usługę",
      "Update service code": "Zaktualizuj usługę",
      "Delete service code": "Usuń usługę",
      "Service code deleted successfully": "Usługa została usunięta pomyślnie",
      "Failed to delete service code": "Usuwanie usługi nie powiodło się",
      "Deleting this service code will permanently remove it from the system. This action cannot be undone.": "Usunięcie tej usługi spowoduje trwałe usunięcie jej z systemu. Ta akcja nie może zostać cofnięta.",
      "Deleting this job service code will permanently remove it from the system. This action cannot be undone.": "Usunięcie tej usługi spowoduje trwałe usunięcie jej z systemu. Ta akcja nie może zostać cofnięta.",
      // Services catalog (JobService)
      "Add new service": "Dodaj nową usługę",
      "Update service": "Zaktualizuj usługę",
      "Delete service": "Usuń usługę",
      "Service deleted successfully": "Usługa została usunięta pomyślnie",
      "Failed to delete service": "Usuwanie usługi nie powiodło się",
      "Deleting this service will permanently remove it from the catalog. This action cannot be undone.": "Usunięcie tej usługi spowoduje trwałe usunięcie jej z katalogu. Ta akcja nie może zostać cofnięta.",
      // Issues catalog (JobIssue)
      "Issues Catalog": "Katalog usterek",
      "Issues-catalog": "Katalog usterek",
      "Add new issue": "Dodaj nową usterkę",
      "Update issue": "Zaktualizuj usterkę",
      "Delete issue": "Usuń usterkę",
      "Issue deleted successfully": "Usterka została usunięta pomyślnie",
      "Failed to delete issue": "Usuwanie usterki nie powiodło się",
      "Deleting this issue will permanently remove it from the catalog. This action cannot be undone.": "Usunięcie tej usterki spowoduje trwałe usunięcie jej z katalogu. Ta akcja nie może zostać cofnięta.",
      "Add part": "Dodaj produkt",
      "Update part": "Zaktualizuj produkt",
      "Delete part": "Usuń produkt",
      "Part deleted successfully": "Produkt został usunięty pomyślnie",
      "Failed to delete part": "Usuwanie produktu nie powiodło się",
      "Deleting this part will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego elementu urządzenia spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "Add ordered part": "Dodaj zamówienie",
      "Update ordered part": "Zaktualizuj zamówienie",
      "Delete ordered part": "Usuń zamówienie",
      "Ordered part deleted successfully": "Zamówienie zostało usunięte pomyślnie",
      "Failed to delete ordered part": "Usuwanie zamówienia nie powiodło się",
      "Deleting this ordered part will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego zamówienia spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "Update used part": "Zaktualizuj użyty element",
      "Delete used part": "Usuń użyty element",
      "Used part deleted successfully": "Użyty element został usunięty pomyślnie",
      "Failed to delete used part": "Usuwanie użytego elementu nie powiodło się",
      "Deleting this used part will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego użytego elementu spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      // Contract tabs and basic info
      "Basic info": "Informacje podstawowe",
      "Financial Information": "Informacje finansowe",
      "Contract Terms Details": "Szczegóły pozycji umowy",
      "Settlement kinds": "Rodzaje rozliczeń",
      "Contract Dates": "Daty umowy",
      "Client Information": "Informacje o kliencie",
      // Contract terms
      "Contract Terms list": "Lista warunków umowy",
      "Contract Position": "Pozycja umowy",
      "Contract Positions": "Pozycje umowy",
      "Equipment Information": "Informacje o urządzeniu",
      "Delete contract term": "Usuń warunek umowy",
      "Contract term deleted successfully": "Warunek umowy został usunięty pomyślnie",
      "Failed to delete contract term": "Usuwanie warunku umowy nie powiodło się",
      "Update contract term": "Zaktualizuj warunek umowy",
      "Generate Annex": "Wygeneruj aneks",
      "Waiting to be implemented": "Oczekuje na implementację",
      // Settlements
      "Settlements list": "Lista rozliczeń",
      "Settlement": "Rozliczenie",
      "Add new settlement": "Dodaj nowe rozliczenie",
      "Update settlement": "Zaktualizuj rozliczenie",
      "Delete settlement": "Usuń rozliczenie",
      "Settlement deleted": "Rozliczenie usunięte",
      "Settlement deleted successfully": "Rozliczenie zostało usunięte pomyślnie",
      "Failed to delete settlement": "Usuwanie rozliczenia nie powiodło się",
      "Total Overridden": "Suma nadpisana",
      "Confirmed date": "Data potwierdzenia",
      "Confirmed By": "Potwierdzone przez",
      "Contract Terms": "Warunki umowy",
      "Numeration schema": "Schemat numeracji",
      "Please select a contract term": "Proszę wybrać warunek umowy",
      "Please select a contract": "Proszę wybrać umowę",
      "Failed to fetch equipment": "Pobieranie urządzeń nie powiodło się",
      "Failed to fetch contract": "Pobieranie umowy nie powiodło się",
      "Failed to fetch contracts": "Pobieranie umów nie powiodło się",
      "Failed to generate settlement": "Wygenerowanie rozliczenia nie powiodło się",
      "Settlement generated successfully": "Rozliczenie zostało wygenerowane pomyślnie",
      "Settlements generated successfully": "Rozliczenia zostały wygenerowane pomyślnie",
      "Some settlements failed to generate": "Niektóre rozliczenia nie zostały wygenerowane",
      "Created at": "Data utworzenia",
      "Updated at": "Data aktualizacji",
      "Status changed at": "Data zmiany",
      // Contract term prices
      "Prices": "Stawki",
      "Start Counter": "Licznik początkowy",
      "End Counter": "Licznik końcowy",
      "Included in Rent": "Wliczone w najem",
      "Net rent price": "Cena najmu netto",
      "Deleting this contract term will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego warunku umowy spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "Select a contract term to generate a settlement": "Wybierz warunek umowy, aby wygenerować rozliczenie",
      "Generate settlement": "Wygeneruj rozliczenie",
      "Generate settlements": "Wygeneruj rozliczenia",
      "Settlement Creator": "Kreator rozliczeń",
      "Manual generation": "Generowanie ręczne",
      "Pending settlements": "Rozliczenia oczekujące",
      "No pending settlements": "Brak oczekujących rozliczeń",
      "Filter list by this contract": "Filtruj listę po tej umowie",
      "Filter list by this client": "Filtruj listę po tym kliencie",
      "Select contract": "Wybierz umowę",
      "Next auto settlement dates": "Najbliższe daty automatycznych rozliczeń",
      "No equipment available": "Brak dostępnych urządzeń",
      "Resolve pending settlements before generating new ones": "Rozwiąż oczekujące rozliczenia przed wygenerowaniem nowych",
      "Actions needed:": "Wymagane działania:",
      "Ready to confirm": "Gotowe do potwierdzenia",
      "Confirmed": "Potwierdzone",
      "Add counter": "Dodaj licznik",
      "Add counter value": "Dodaj stan licznika",
      "Counter details": "Szczegóły liczników",
      "Manage settlement": "Zarządzaj rozliczeniem",
      "Counter values needed": "Wymagane wartości liczników",
      "Confirm counter values": "Zatwierdź",
      "No action needed": "Nie są wymagane żadne działania",
      "Failed to load settlement": "Nie udało się wczytać rozliczenia",
      "Contract number": "Numer umowy",
      "Previous": "Poprzedni",
      "Current": "Aktualny",
      "Add Scan counter": "Dodaj licznik skanów",
      "Add Scan counter for {{equipment}}": "Dodaj licznik skanów dla {{equipment}}",
      "Please enter at least one counter value": "Wprowadź przynajmniej jedną wartość licznika",
      "Counter values saved": "Wartości liczników zapisane",
      "Remove": "Usuń",
      "Fully settled only": "Tylko w pełni rozliczone",
      "{{count}} pending settlement(s) not included in this total": "{{count}} rozliczeń oczekujących nieuwzględnionych w tej sumie",
      "Counter value": "Stan licznika",
      "Counter diff": "Różnica",
      "Counter source": "Źródło",
      "Previous value": "Poprzednia wartość",
      "Old counter": "Stary licznik",
      "New counter": "Nowy licznik",
      "Edit": "Edytuj",
      "Edit counter value": "Edytuj stan licznika",
      "Read date": "Data odczytu",
      "Counter value saved": "Stan licznika został zapisany",
      "Failed to add counter value": "Nie udało się zapisać stanu licznika",
      "Counter readings by provider": "Odczyty liczników wg dostawcy",
      "Action": "Akcja",
      "Use this value": "Użyj tej wartości",
      "Restore defaults": "Przywróć domyślne",
      "Failed to use this counter value": "Nie udało się użyć tej wartości licznika",
      "Default counter selection restored": "Przywrócono domyślny wybór licznika",
      "Failed to restore default counter selection": "Nie udało się przywrócić domyślnego wyboru licznika",
      "Not set": "Nie ustawiono",
      "Please enter counter value": "Wprowadź stan licznika",
      "Please fill at least one counter.": "Proszę wypełnić przynajmniej jeden licznik.",
      "Sale date is required": "Data sprzedaży jest wymagana",
      "Settlement confirmed": "Rozliczenie zostało potwierdzone",
      "Failed to confirm settlement": "Nie udało się potwierdzić rozliczenia",
      "Confirm settlement": "Potwierdź rozliczenie",
      "Equipment is required to add counter": "Wymagane jest urządzenie do dodania licznika",
      "Deleting this settlement will permanently remove it from the system. This action cannot be undone.": "Usunięcie tego rozliczenia spowoduje trwałe usunięcie go z systemu. Ta akcja nie może zostać cofnięta.",
      "Positions": "Pozycje rozliczeniowe",
      "Extra positions": "Pozycje dodatkowe",
      "Position name": "Nazwa pozycji",
      "Position price": "Cena pozycji",
      "Add position": "Dodaj pozycję",
      "Save positions": "Zapisz pozycje",
      "Extra positions saved": "Pozycje dodatkowe zostały zapisane",
      "Failed to save extra positions": "Nie udało się zapisać pozycji dodatkowych",
      "Please complete both name and price for each extra position": "Uzupełnij nazwę i cenę dla każdej pozycji dodatkowej",
      "Invalid extra position price": "Nieprawidłowa cena pozycji dodatkowej",
      "Inflation rate": "Stopa inflacji",
      "Inflation": "Inflacja",
      "Save inflation rate": "Zapisz stopę inflacji",
      "Inflation rate saved": "Stopa inflacji została zapisana",
      "Failed to save inflation rate": "Nie udało się zapisać stopy inflacji",
      "Invalid inflation rate percent": "Nieprawidłowa stopa inflacji (%)",
      "Inflation rate percent must be between 0 and 100":
        "Stopa inflacji musi być w zakresie od 0 do 100",
      "Inflation rate (%)": "Stopa inflacji (%)",
      "Current counter": "Aktualny licznik",
      "Previous counter": "Poprzedni licznik",
      "Previous counter values": "Poprzednie wartości liczników",
      "Latest counter readings": "Ostatnie odczyty liczników",
      "Counter type": "Typ licznika",
      "Investigation reasons": "Kwestie wymagające weryfikacji",
      "Refresh settlement": "Odśwież rozliczenie",
      "Are you sure you want to refresh this confirmed settlement? Totals will be recalculated.": "Czy na pewno chcesz odświeżyć to potwierdzone rozliczenie? Sumy zostaną przeliczone.",
      "This settlement is already confirmed.": "To rozliczenie jest już potwierdzone.",
      "Settlement refreshed successfully": "Rozliczenie zostało odświeżone pomyślnie",
      "Failed to refresh settlement": "Odświeżenie rozliczenia nie powiodło się",
      "Failed to update calculation": "Aktualizacja obliczeń nie powiodła się",
      "Edit confirmed settlement": "Edytuj potwierdzone rozliczenie",
      "Are you sure you want to edit this confirmed settlement? It will be moved back to an editable state and its totals recalculated.": "Czy na pewno chcesz edytować to potwierdzone rozliczenie? Zostanie ono przywrócone do stanu edytowalnego, a jego sumy zostaną przeliczone.",
      "Failed to reopen settlement": "Nie udało się ponownie otworzyć rozliczenia do edycji",
      "Send reminder": "Wyślij przypomnienie",
      "Select settlements to send reminders for outdated counters": "Wybierz rozliczenia, dla których wysłać przypomnienia o nieaktualnych licznikach",
      "Deselect all": "Odznacz wszystkie",
      "Select all": "Zaznacz wszystkie",
      "Select": "Zaznacz",
      "No settlements need reminders at this time.": "Obecnie brak rozliczeń wymagających przypomnienia.",
      "Please select at least one settlement": "Proszę wybrać co najmniej jedno rozliczenie",
      "Please fill in both title and message": "Proszę wypełnić oba pola tytułu i wiadomości",
      "Reminders sent successfully": "Przypomnienia wysłane pomyślnie",
      "Failed to send reminders": "Wysyłanie przypomnień nie powiodło się",
      "Sending...": "Wysyłanie...",
      "Send reminders ({{count}} selected)": "Wyślij przypomnienia ({{count}} zaznaczonych)",
      "No email available": "Brak dostępnego e-maila",
      "Add an email before selecting this settlement": "Dodaj e-mail przed zaznaczeniem tego rozliczenia",
      "Filter": "Filtr",
      "All settlements": "Wszystkie rozliczenia",
      "All settlement kinds": "Wszystkie rodzaje rozliczeń",
      "Selected settlements": "Zaznaczone rozliczenia",
      "Unselected settlements": "Niezaznaczone rozliczenia",
      "With email": "Z e-mailem",
      "Without email": "Bez e-maila",
      "Search settlements": "Szukaj rozliczeń",
      "No settlements match current filters.": "Brak rozliczeń pasujących do bieżących filtrów.",
      "Failed to fetch settlements": "Pobieranie rozliczeń nie powiodło się",
      "Failed to fetch data": "Pobieranie danych nie powiodło się",
      "Edit email": "Edytuj e-mail",
      "Apply": "Zastosuj",
      "Apply to": "Zastosuj do",
      "This Equipment": "To urządzenie",
      "This Client": "Ten klient",
      "All Equipments in this contract": "Wszystkie urządzenia w tej umowie",
      "All Contracts": "Wszystkie umowy",
      "Email updated successfully": "E-mail zaktualizowany pomyślnie",
      "Email cleared successfully": "E-mail wyczyszczony pomyślnie",
      "Failed to update email": "Aktualizacja e-maila nie powiodła się",
      "Please enter a valid email address": "Proszę podać prawidłowy adres e-mail",
      "Leave empty to clear the email": "Pozostaw puste, aby wyczyścić e-mail",
      "Reminder": "Przypomnienie",
      "Last reminder at": "Ostatnie przypomnienie",
      "Message template": "Szablon wiadomości",
      "Reminder: Counter reading needed": "Przypomnienie: Wymagany odczyt licznika",
      "Message": "Wiadomość",
      "Available tags: {CLIENT_NAME}, {EQUIPMENTS_DETAILS}, {COMPANY_NAME}": "Dostępne tagi: {CLIENT_NAME}, {EQUIPMENTS_DETAILS}, {COMPANY_NAME}",
      "Reminder message": "Wiadomość przypomnienia",
      "Next reminder available after days": "Następne przypomnienie dostępne po dniach",
      "Reminder template title": "Tytuł szablonu przypomnienia",
      "Reminder template message": "Wiadomość szablonu przypomnienia",
      "Reminder templates support placeholders that are replaced with actual values when sending.": "Szablony przypomnień obsługują symbole zastępcze, które są zastępowane rzeczywistymi wartościami przy wysyłce.",
      "Tag details are listed below. You can use the same tags in the title.": "Szczegóły tagów znajdziesz poniżej. Tych samych tagów możesz używać także w tytule.",
      "Available tags": "Dostępne tagi",
      "client name": "nazwa klienta",
      "equipments details": "szczegóły urządzeń",
      "full equipment details (name and serial, bullet list)": "pełne dane urządzeń (nazwa i numer seryjny, lista punktowana)",
      "equipment names (bullet list)": "nazwy urządzeń (lista punktowana)",
      "equipment serial numbers (bullet list)": "numery seryjne urządzeń (lista punktowana)",
      "equipment installation addresses (bullet list)": "adresy instalacji urządzeń (lista punktowana)",
      "equipment name": "nazwa urządzenia",
      "contract number": "numer umowy",
      "workspace or company name": "nazwa firmy lub przestrzeni roboczej",
      "company logo": "logo firmy",
      "sequential number (required)": "numer kolejny (wymagany)",
      "year": "rok",
      "month": "miesiąc",
      "day": "dzień",
      "Next reminder can be sent after": "Następne przypomnienie dostępne za",
      "days": "dni",
      "Yes": "Tak",
      "No": "Nie",
      "Stock-status": "Stan magazynu",
      "Service-codes": "Usługi",
      "Jobs list": "Lista zleceń",
      "Title": "Tytuł",
      "kind": "Rodzaj",
      "Finished": "Zakończone",
      "Services": "Usługi",
      "Services Catalog": "Katalog usług",
      "Planned For": "Zaplanowane na",
      "Unit": "Jednostka",
      "Stock Quantity": "Dostępna ilość",
      "Notification Threshold": "Alarm od",
      "Ordered Parts": "Zamówienia",
      "Used Parts": "Użyte elementy",
      "Ordered-parts": "Zamówienia",
      "Used-parts": "Użyte elementy",
      "Delivered At": "Dostarczone dnia",
      "Quantity": "Ilość",
      "Used Quantity": "Zużyta ilość",
      "Availability": "Dostępność",
      "Price Net": "Cena netto",
      "Total Cost": "Koszt całkowity",
      "VAT": "VAT",
      "Net": "Netto",
      "Gross": "Brutto",
      "Calculated as net (VAT 23%)": "Wyliczone jako netto (VAT 23%)",
      "Ordered By": "Zamówione przez",
      "Ordered Part": "Zamówienie",
      "From Order": "Z zamówienia",
      "Ordered": "Zamówiony",
      "Delivered": "Dostarczony",
      "Used": "Zużyty",
      "Used Part": "Użyty element",
      "Used At": "Użyto",
      "Order": "Zamówienie",
      "Part": "Produkt",
      "Used for": "Użyte dla",
      "Part Details": "Szczegóły produktu",
      "Current Price": "Aktualna cena",
      "Stock Value": "Wartość w magazynie",
      "Total Ordered": "Łącznie zamówiono",
      "Total Used": "Łącznie zużyto",
      "Last Delivery": "Ostatnia dostawa",
      "Newest order": "Najnowsze zamówienie",
      "Next issued from": "Następne wydanie z",
      "Edit current order": "Edytuj aktualne zamówienie",
      "Low stock": "Niski stan",
      "left": "pozostało",
      "Below notification threshold": "Poniżej progu powiadomienia",
      "No notification threshold set": "Nie ustawiono progu powiadomienia",
      "No delivered order with stock left": "Brak dostarczonego zamówienia z pozostałą ilością",
      "A notification is sent once stock reaches this level.": "Po osiągnięciu tego stanu wysyłane jest powiadomienie.",
      "Stock is used oldest delivery first, so the next use is charged against the oldest order still holding stock - a different price from the newest one whenever the part was re-ordered at a new rate.":
        "Produkt wydawany jest według najstarszej dostawy, więc kolejne użycie zostanie rozliczone z najstarszego zamówienia, na którym pozostał jeszcze stan - po innej cenie niż najnowsze, jeśli produkt zamówiono ponownie po nowej stawce.",
      // Contract multistep form
      "Contract Information": "Informacje o umowie",
      "Review & Submit": "Przegląd i zatwierdzenie",
      "Latest contract number for this client: {{number}}":
        "Ostatni numer umowy dla tego klienta: {{number}}",
      "Latest created contract number: {{number}}": "Numer ostatnio utworzonej umowy: {{number}}",
      "A contract with number {{number}} already exists.": "Umowa o numerze {{number}} już istnieje.",
      "This client has no contracts yet.": "Ten klient nie ma jeszcze żadnej umowy.",
      "Please fill in all required contract fields": "Proszę wypełnić wszystkie wymagane pola umowy",
      "Please fill in all required equipment fields": "Proszę wypełnić wszystkie wymagane pola urządzenia",
      "Please fill required fields": "Proszę wypełnić wymagane pola",
      "Contract created successfully": "Umowa została utworzona pomyślnie",
      "Contract updated successfully": "Umowa została zaktualizowana pomyślnie",
      "Failed to create contract": "Utworzenie umowy nie powiodło się",
      "Failed to process contract": "Przetwarzanie umowy nie powiodło się",
      "Start date": "Data rozpoczęcia",
      "End date": "Data zakończenia",
      "This contract has no assigned equipments, do you want to close it from today?": "Ta umowa nie ma przypisanych urządzeń, czy chcesz ją zamknąć od dzisiaj?",
      "Close it from today": "Zamknij od dzisiaj",
      "Issuance date": "Data wystawienia",
      "Signature date": "Data podpisu",
      "Settlement cycle": "Cykl rozliczeniowy",
      "Separate counter": "Oddzielny licznik",
      "Common counter": "Wspólny licznik",
      "Common counter for {{count}} equipments": "Wspólny licznik dla {{count}} urządzeń",
      "Daily": "Dziennie",
      "Weekly": "Tygodniowo",
      "Biweekly": "Dwutygodniowo",
      "Monthly": "Miesięcznie",
      "First day of each month": "Pierwszy dzień każdego miesiąca",
      "Last day of each month": "Ostatni dzień każdego miesiąca",
      "Quaterly": "Kwartalnie",
      "Yearly": "Rocznie",
      "Next settlement date": "Data następnego rozliczenia",
      "Rent price": "Abonament",
      "Rent price (gross)": "Abonament brutto",
      "Copy financial data": "Skopiuj dane finansowe",
      "Copy financial data from": "Skopiuj dane finansowe z",
      "Select a position": "Wybierz pozycję",
      "Gross rent price": "Abonament brutto",
      "Price (gross)": "Cena brutto",
      "Values stored as": "Wartości przechowywane jako",
      "Net (Netto)": "Netto",
      "Gross (Brutto)": "Brutto",
      "Store values as gross (brutto)": "Przechowuj wartości jako brutto",
      "For clients that require gross-only settlements (e.g. government-related entities). Rent and prices will be entered and stored as gross amounts, with no net/gross conversion.":
        "Dla klientów wymagających rozliczeń tylko w kwotach brutto (np. podmioty publiczne). Abonament i ceny będą wprowadzane i zapisywane jako kwoty brutto, bez przeliczania netto/brutto.",
      "This contract's values are stored and settled as gross (brutto) amounts":
        "Wartości tej umowy są przechowywane i rozliczane jako kwoty brutto",
      "This equipment was newly attached to this contract - first settlement for it here":
        "To urządzenie zostało nowo podłączone do tej umowy — to jego pierwsze rozliczenie w jej ramach",
      "This equipment's term has already been ended on this contract":
        "Pozycja umowy zawierająca to urządzenie została już zakończona w ramach tej umowy",
      "This contract has already ended": "Ta umowa została już zakończona",
      "Read on {{date}}": "Odczytano dnia {{date}}",
      "(included proportions of: {{factor}})": "(uwzględniono proporcję: {{factor}})",
      "Inflation condition": "Warunek inflacyjny",
      "Inflation rate percent": "Stopa inflacji (%)",
      "Add after exceeding the limit": "Dolicz po przekroczeniu limitu",
      "Always add": "Dolicz zawsze",
      "Add Price": "Dodaj stawkę",
      "Start counter": "Licznik początkowy",
      "End counter": "Licznik końcowy",
      "End counters": "Liczniki końcowe",
      "Add end counter": "Dodaj licznik końcowy",
      "Deactivating this term closes out its billing — provide a final reading for each price so its last settlement can be calculated correctly.": "Dezaktywacja tego okresu zamyka jego rozliczenia — podaj końcowy odczyt dla każdej ceny, aby ostatnie rozliczenie mogło zostać prawidłowo obliczone.",
      "All prices already have an end counter.": "Wszystkie ceny mają już przypisany licznik końcowy.",
      "Add at least one end counter before saving to close out this term.": "Dodaj co najmniej jeden licznik końcowy przed zapisaniem, aby zamknąć ten okres.",
      "Included in rent": "Wliczone w abonament",
      "Per usage": "Za zużycie",
      "Rent with usage limit": "Abonament z limitem stron",
      "Rent with amount limit": "Abonament z limitem kwotowym",
      "Rent without limits": "Abonament bez limitów",
      "Usage billing": "Rozliczanie zużycia",
      "Included in the rent (extra charge only above that amount)": "W cenie abonamentu (dopłata dopiero po przekroczeniu)",
      "From the first page (rent covers the device only)": "Od pierwszej strony (abonament tylko za urządzenie)",
      "The rent is a flat device fee — every page is billed separately, starting from the first one.": "Abonament to stała opłata za urządzenie — każda strona jest rozliczana osobno, już od pierwszej sztuki.",
      "Pages are covered by the rent up to its value — you only pay extra once usage goes over it.": "Strony są pokrywane przez abonament do jego wysokości — dopłacasz dopiero po przekroczeniu.",
      "Add Equipment": "Dodaj urządzenie",
      "Fill from client address": "Uzupełnij adresem klienta",
      "Fill from last contract's address": "Uzupełnij adresem z ostatniej umowy",
      "Fill from previous position's address": "Uzupełnij adresem z poprzedniej pozycji",
      "The previous position has no installation address": "Poprzednia pozycja nie ma adresu instalacji",
      "Closing this position clears the installation address of its equipment - the equipment comes back to the company.":
        "Zamknięcie tej pozycji usuwa adres instalacji jej urządzeń - urządzenia wracają do firmy.",
      "Client address is not available": "Adres klienta nie jest dostępny",
      "No installation address found in this client's previous contracts": "Nie znaleziono adresu instalacji w poprzednich umowach tego klienta",
      "Failed to fetch client data": "Nie udało się pobrać danych klienta",
      "Failed to fetch next contract number": "Nie udało się pobrać następnego numeru umowy",
      "Failed to update contract": "Aktualizacja umowy nie powiodła się",
      "Only one common counter equipment group is allowed per contract": "W ramach jednej umowy dozwolona jest tylko jedna grupa wspólnego licznika",
      "defined": "zdefiniowanych",
      "Back": "Wstecz",
      "Creating...": "Tworzenie...",
      "Rent Price": "Abonament",
      "Next": "Dalej",
      "Client": "Klient",
      "Update workspace": "Zaktualizuj przestrzeń roboczą",
      // Numeration schemas
      "Numeration Schemas": "Schematy numeracji",
      "Numeration Schema Details": "Szczegóły schematu numeracji",
      "Template": "Szablon",
      "Numeration schema created successfully": "Schemat numeracji został utworzony pomyślnie",
      "Numeration schema creation failed": "Utworzenie schematu numeracji nie powiodło się",
      "Numeration schema updated successfully": "Schemat numeracji został zaktualizowany pomyślnie",
      "Numeration schema update failed": "Aktualizacja schematu numeracji nie powiodła się",
      "Numeration schema deleted successfully": "Schemat numeracji został usunięty pomyślnie",
      "Numeration schema deletion failed": "Usunięcie schematu numeracji nie powiodło się",
      "Are you sure you want to delete the numeration schema": "Czy jesteś pewny, że chcesz usunąć schemat numeracji",
      "Create numeration schema": "Utwórz schemat numeracji",
      "Update numeration schema": "Zaktualizuj schemat numeracji",
      "Edit numeration schema": "Edytuj schemat numeracji",
      "Delete numeration schema": "Usuń schemat numeracji",
      "Add numeration schema": "Dodaj schemat numeracji",
      "Numeration-schemas": "Schematy numeracji",
      "Deleting this numeration schema will permanently remove it from the system.": "Usunięcie tego schematu numeracji spowoduje trwałe usunięcie go z systemu.",
      "Use {COUNTER}, {YEAR}, {MONTH}, {DAY} tags. COUNTER is required. Example: CT/{COUNTER}/{YEAR}/{MONTH}/{DAY}": "Użyj tagów {COUNTER}, {YEAR}, {MONTH}, {DAY}. COUNTER jest wymagany. Przykład: UM/{COUNTER}/{YEAR}/{MONTH}/{DAY}",
      "Template uses placeholders for the number. COUNTER is required. Example: CT/{COUNTER}/{YEAR}/{MONTH}/{DAY}": "Szablon używa symboli zastępczych dla numeru. COUNTER jest wymagany. Przykład: UM/{COUNTER}/{YEAR}/{MONTH}/{DAY}",
      // Dashboard / Analytics
      "No analytics data available": "Brak danych analitycznych",
      "Overdue Past Months": "Zaległe z poprzednich miesięcy",
      "All Current Month": "Wszystkie w bieżącym miesiącu",
      "Valid counters / required counters": "Ważne liczniki / wymagane liczniki",
      "Ready to Settle / Current Month": "Gotowe do rozliczenia / Bieżący miesiąc",
      "Ready to Settle / Selected Month": "Gotowe do rozliczenia / Wybrany miesiąc",
      "Ready to settle": "Gotowe do rozliczenia",
      "Confirmed / Current Month": "Potwierdzone / Bieżący miesiąc",
      "Settled / Ready to Settle": "Rozliczone / Gotowe do rozliczenia",
      "Equipment Counters Added / Selected Month": "Dodane liczniki urządzeń / Wybrany miesiąc",
      "Email report": "Raport e-mail",
      "Source e-mail": "Źródłowy e-mail",
      "Source file": "Plik źródłowy",
      "Ingestion source not recorded": "Nie zapisano źródła pobrania",
      "PDF": "PDF",
      "No equipment found": "Nie znaleziono urządzeń",
      "Failed to load equipment": "Nie udało się załadować urządzeń",
      "Expiring Soon": "Wygasające wkrótce",
      "Jobs by Status": "Zlecenia według statusu",
      "Not Assigned": "Nieprzypisane",
      "In Progress": "W realizacji",
      "Pending": "Oczekujące",
      "For Verification": "Do weryfikacji",
      "For verification": "Do weryfikacji",
      "For Improvement": "Do poprawy",
      "For improvement": "Do poprawy",
      "Light mode": "Tryb jasny",
      "Dark mode": "Tryb ciemny",
      "Theme": "Motyw",
      // Landing Page (kept in sync with the public landing site copy)
      "Office equipment rental, billing and service in one platform": "Najem, rozliczenia i serwis urządzeń w jednym miejscu",
      "Equipment and contracts": "Urządzenia i umowy",
      "Keep every leased device on a contract: where it stands, who uses it, what it costs and when the term ends.": "Każde urządzenie w najmie przypisane do umowy: gdzie stoi, kto go używa, ile kosztuje i czy jest rentowne.",
      "Meter readings": "Odczyty liczników",
      "Collect counter readings per device, keep their full history and catch the ones that do not add up.": "Zbieraj odczyty liczników dla każdej drukarki automatycznie, przechowuj pełną historię.",
      "Bill each device by its counter at your own rates and let monthly settlements generate themselves.": "Rozliczaj każde urządzenie według stanu licznika i własnych stawek, a miesięczne rozliczenia wygenerują się automatycznie.",
      "Sale summary": "Podsumowanie sprzedaży",
      "Ordering": "Sortowanie",
      "Newest number first": "Od najnowszego numeru umowy",
      "Oldest number first": "Od najstarszego numeru umowy",
      "Grouping": "Grupowanie",
      "Display options": "Opcje wyświetlania",
      "Group by client": "Grupuj według klienta",
      "Ungrouped": "Bez grupowania",
      "You do not have permission to view the sale summary.": "Nie masz uprawnień do podglądu podsumowania sprzedaży.",
      "Profitability": "Rentowność",
      "Show each settlement's cost and profitability": "Pokaż koszt i rentowność każdego rozliczenia",
      "Show the inflation rate applied to each settlement": "Pokaż stopę inflacji zastosowaną w każdym rozliczeniu",
      "Sorted by margin percentage": "Sortowane wg procentowej marży",
      "Jobs included in this cost": "Zlecenia wliczone w ten koszt",
      "Used parts cost more than this row earned": "Koszt zużytych części przewyższa wypracowaną rentowność",
      "Profitability per equipment": "Rentowność urządzeń",
      "Profitability per contract": "Rentowność umów",
      "Profitability per client": "Rentowność klientów",
      "Mean job execution cost": "Średni koszt wykonania zlecenia",
      "Profitability (net)": "Rentowność (netto)",
      "Usage costs": "Koszty zużycia",
      "Black page cost": "Koszt strony czarno-białej",
      "Color page cost": "Koszt strony kolorowej",
      "Scanned page cost": "Koszt strony skanowanej",
      "Additional costs": "Koszty dodatkowe",
      "Revenue (net)": "Przychód (netto)",
      "Cost": "Koszt",
      "Cost breakdown": "Szczegóły kosztów",
      "Failed to load the cost breakdown": "Nie udało się załadować szczegółów kosztów",
      "Printed pages": "Wydrukowane strony",
      "Cost per page": "Koszt strony",
      "Costed by": "Wyceniono wg",
      "None of the job's services has a price": "Żadna z usług zlecenia nie ma ceny",
      "No pages were printed in this period.": "W tym okresie nie wydrukowano żadnych stron.",
      "No jobs were finished in this period.": "W tym okresie nie zakończono żadnych zleceń.",
      "No parts were used on these jobs.": "W tych zleceniach nie użyto żadnych części.",
      "Cost component": "Składnik kosztu",
      "Settlements without saved details ({{count}})": "Rozliczenia bez zapisanych szczegółów ({{count}})",
      "{{count}} settlement(s) were confirmed before their cost details were saved. Their costs are included in the totals but not listed - recalculate profitability for their month to list them.": "Liczba rozliczeń zatwierdzonych przed zapisywaniem szczegółów kosztów: {{count}}. Ich koszty są wliczone w sumy, ale nie zostały wymienione - przelicz rentowność za ich miesiąc, aby je wyświetlić.",
      "Per equipment": "Urządzenia",
      "Per contract": "Umowy",
      "Per client": "Klienci",
      "Unprofitable": "Nierentowne",
      "Equipment under profitability": "Urządzenia w analizie rentowności",
      "Contracts under profitability": "Umowy w analizie rentowności",
      "Clients under profitability": "Klienci w analizie rentowności",
      "You do not have permission to view profitability.": "Nie masz uprawnień do wyświetlania rentowności.",
      "Failed to load profitability": "Nie udało się wczytać rentowności",
      "Average cost of executing a single service job. Used in settlement profitability for jobs with no priced service - a job with priced services costs their prices instead.": "Średni koszt wykonania pojedynczego zlecenia serwisowego. Używany w rentowności rozliczenia dla zleceń bez wycenionej usługi - zlecenie z wycenionymi usługami kosztuje tyle, ile ich ceny.",
      "Sale-summary": "Podsumowanie sprzedaży",
      "Sale Date": "Data sprzedaży",
      "Search by machine serial, client, contract number": "Szukaj po numerze seryjnym urządzenia, kliencie lub numerze umowy",
      "Total Value": "Wartość całkowita",
      "No data available": "Brak dostępnych danych",
      "There are no settlements for the given parameters.": "Brak rozliczeń dla podanych parametrów.",
      "Failed to load summary": "Nie udało się załadować podsumowania",
      "Failed to load more results": "Nie udało się załadować kolejnych wyników",
      "Retry": "Spróbuj ponownie",
      "Counter Kind": "Rodzaj licznika",
      "Last value": "Ostatni",
      "New value": "Nowy",
      "Difference": "Różnica",
      "Price/Unit": "Stawka",
      "Total for Usage": "Kwota ponad limit",
      "Total with usage calculated as the contract's billed pages multiplied by their price. Settlements round usage separately, so the two totals can differ by a few grosze.": "Suma z kwotą za wydruki policzoną jako rozliczone strony z całej umowy pomnożone przez stawkę. Rozliczenia zaokrąglają kwotę za wydruki osobno, więc obie sumy mogą różnić się o kilka groszy.",
      "Black counter increase": "Przyrost licznika czarnego",
      "Color counter increase": "Przyrost licznika kolorowego",
      "Total calculated": "Suma obliczona",
      "Total Calculated": "Suma obliczona",
      "Overridden value": "Suma nadpisana",
      "Total": "Razem",
      "No positions": "Brak pozycji",
      "Summary": "Podsumowanie",
      "Services-catalog": "Katalog usług",
      "Counter": "Licznik",
      "Short name": "Skrócona nazwa",
      "Relevant date": "Istotna data",
      // Job Form translations
      "Planned for": "Zaplanowane na",
      "Finished at": "Ukończone dnia",
      "Assigned to": "Przypisane do",
      "Add service": "Dodaj usługę",
      "Service description": "Opis usługi",
      "Service finished at": "Usługa ukończona dnia",
      "Unable to fetch next number.": "Nie udało się pobrać następnego numeru.",
      "Codes": "Kody",
      "Update": "Zaktualizuj",
      "Failed to fetch equipments": "Nie udało się pobrać urządzeń",
      "Producers": "Producenci",
      "Extra-positions": "Pozycje dodatkowe",
      "last": "ostatnia",
      "Model count": "Liczba modeli",
      "Attachments": "Załączniki",
      "Add file": "Dodaj plik",
      "Company logo": "Logo firmy",
      "Drop file here or click to browse": "Upuść plik tutaj lub kliknij, aby wybrać z dysku",
      "Uploading…": "Wgrywanie…",
      "Failed to upload file.": "Nie udało się wgrać pliku.",
      "Failed to remove attachment.": "Nie udało się usunąć załącznika.",
      "Attached when the job was reported.":
        "Dołączono podczas zgłaszania zlecenia.",
      "Attachment": "Załącznik",
      "Dashboard configuration": "Konfiguracja dashboardu",
      "Contracts expiring soon days": "Oznaczaj umowy jako wygasające wkrótce jeśli do końca zostało mniej niż (dni)",
      "Date": "Data",
      // Status transition actions
      "Status Transition Actions": "Akcje przejść statusów",
      "Previous status": "Poprzedni status",
      "New status": "Nowy status",
      "Required fields": "Wymagane pola",
      "Validation": "Walidacja",
      "Add status transition action": "Dodaj akcję przejścia statusu",
      "Edit status transition action": "Edytuj akcję przejścia statusu",
      "Delete status transition action": "Usuń akcję przejścia statusu",
      "Deleting this status transition action will permanently remove it from the system.": "Usunięcie tej akcji przejścia statusu trwale usunie ją z systemu.",
      "Status transition action deleted successfully": "Akcja przejścia statusu została usunięta",
      "Status transition action deletion failed": "Nie udało się usunąć akcji przejścia statusu",
      "Status transition action created successfully": "Akcja przejścia statusu została utworzona",
      "Status transition action saved successfully": "Akcja przejścia statusu została zapisana",
      "Checkbox": "Pole wyboru",
      "Field type": "Typ pola",
      "Counter values": "Wartości liczników",
      "No equipment is assigned to this job, so counter values cannot be provided.":
        "Do tego zlecenia nie przypisano urządzeń, więc nie można wprowadzić wartości liczników.",
      "This job has {{count}} task(s) without equipment assigned. Make sure this is intentional before moving to verification.":
        "To zlecenie ma {{count}} zadanie(a) bez przypisanego urządzenia. Upewnij się, że to zamierzone przed przekazaniem do weryfikacji.",
      "Total pages": "Suma stron",
      "Rejection reason": "Powód odrzucenia",
      "Protected default action": "Chroniona akcja domyślna",
      "This status transition action is protected and cannot be deleted.":
        "Ta akcja przejścia statusu jest chroniona i nie można jej usunąć.",
      "Obligatory fields": "Pola obowiązkowe",
      "No obligatory fields configured.": "Nie skonfigurowano żadnych pól obowiązkowych.",
      "Optional fields": "Pola opcjonalne",
      "No optional fields configured.": "Nie skonfigurowano żadnych pól opcjonalnych.",
      "Applies to": "Dotyczy",
      "Applies to all job kinds.": "Dotyczy wszystkich rodzajów zleceń.",
      "Please fix the errors and try again.": "Popraw błędy i spróbuj ponownie.",
      "Job kinds": "Rodzaje zleceń",
      "Internal": "Wewnętrzne",
      "External with contract": "Zewnętrzne wynikające z umowy",
      "External without contract": "Zewnętrzne bez umowy",
      "Complaint": "Reklamacja",
      "All statuses": "Wszystkie",
      "Assigned to me": "Przypisane do mnie",
      "Suggested as closest": "Sugerowane jako najbliższe",
      "Distance (km)": "Odległość (km)",
      // Technician locations
      "Technicians map": "Mapa serwisantów",
      "Failed to fetch technician locations": "Nie udało się pobrać lokalizacji serwisantów",
      "No technician locations yet": "Brak lokalizacji serwisantów",
      "Location updated": "Lokalizacja z",
      "Accuracy": "Dokładność",
      "Refresh": "Odśwież",
      "Current (up to 15 min)": "Aktualna (do 15 min)",
      "Up to 1 hour": "Do 1 godziny",
      "Up to 6 hours": "Do 6 godzin",
      "Up to 24 hours": "Do 24 godzin",
      "Older than 24 hours": "Starsza niż 24 godziny",
      "just now": "przed chwilą",
      "{{value}} min ago": "{{value}} min temu",
      "{{value}} h ago": "{{value}} godz. temu",
      "{{value}} d ago": "{{value}} dn. temu",
      "Location sharing": "Udostępnianie lokalizacji",
      "Your location is shared with administrators while you use the app, so they can see where technicians are. Your browser will ask for permission next.": "Podczas korzystania z aplikacji Twoja lokalizacja jest udostępniana administratorom, aby mogli zobaczyć, gdzie znajdują się serwisanci. Za chwilę przeglądarka poprosi o zgodę.",
      "Understood": "Rozumiem",
      "All contracts": "Wszystkie umowy",
      "Not settled only": "Tylko nierozliczone",
      "Settlement type": "Rodzaj rozliczenia",
      "Rent and sale": "Najem i sprzedaż",
      "Rent only": "Tylko najem",
      "Sale only": "Tylko sprzedaż",
      "Counter usage summary": "Podsumowanie zużycia liczników",
      "Total income from the start": "Suma przychodów od początku",
      "Quick filters": "Szybkie filtry",
      "Print job": "Drukuj zlecenie",
      "Job Summary": "Podsumowanie zlecenia",
      "In progress": "W realizacji",
      // Settlement automation
      "Settlement Automation": "Automatyzacja rozliczeń",
      "Automation level": "Poziom automatyzacji",
      "Manual": "Ręcznie",
      "Auto-confirm settlements": "Automatyczne zatwierdzanie rozliczeń",
      "Auto-confirm and invoice": "Automatyczne zatwierdzanie i fakturowanie",
      "Auto-confirm, invoice and send to KSeF": "Automatyczne zatwierdzanie, fakturowanie i wysyłka do KSeF",
      "Auto-confirm, invoice, send to KSeF and send to client": "Automatyczne zatwierdzanie, fakturowanie, wysyłka do KSeF i klienta",
      "Settlement automation configuration": "Konfiguracja automatyzacji rozliczeń",
      "Settlement automation run day": "Dzień uruchomienia automatyzacji rozliczeń",
      "Proration cutoff day": "Dzień graniczny proporcji",
      "Day of the month (1-31) on which settlement automation runs for opted-in contracts.":
        "Dzień miesiąca (1–31), w którym uruchamiana jest automatyzacja rozliczeń dla wybranych umów.",
      "For a term that ended this month: only prorate its final settlement if the end counter falls on or before this day (1-31). Past it, it bills a full period instead. Leave empty to always prorate.":
        "Dla okresu umowy zakończonego w tym miesiącu: prorata jego ostatniego rozliczenia jest stosowana tylko, jeśli licznik końcowy przypada w tym dniu (1–31) lub wcześniej. Po tym dniu rozliczenie obejmuje pełny okres. Pozostaw puste, aby zawsze stosować proporcję.",
      "Select the automation level for each contract.": "Wybierz poziom automatyzacji dla każdej umowy.",
      "Automation runs on day {{day}} of each month.":
        "Automatyzacja jest uruchamiana {{day}}. dnia każdego miesiąca.",
      "The automation day is not configured yet. Set it under Settings.":
        "Dzień automatyzacji nie jest jeszcze skonfigurowany. Ustaw go w Ustawieniach.",
      "(runs on day {{day}} of each month)": "(uruchamiane {{day}}. dnia każdego miesiąca)",
      "Search by contract number or client name": "Szukaj po numerze umowy lub nazwie klienta",
      "No contracts found": "Nie znaleziono umów",
      "Automation settings were successfully saved.": "Ustawienia automatyzacji zostały pomyślnie zapisane.",
      "There was an error, please try again.": "Wystąpił błąd, spróbuj ponownie.",
      "Automation": "Automatyzacja",
      "Set automation level": "Ustaw poziom automatyzacji",
      "Select the automation level for this contract.": "Wybierz poziom automatyzacji dla tej umowy.",
      "Select the equipment counter priority provider for this contract.":
        "Wybierz dostawcę priorytetowego liczników urządzeń dla tej umowy.",
      "Automation level updated successfully": "Poziom automatyzacji został zaktualizowany pomyślnie",
      "Failed to update automation level": "Aktualizacja poziomu automatyzacji nie powiodła się",
      // Equipment counter priority provider
      "When set, settlement automation only picks up new counter readings from this provider and ignores readings from any other provider (a Contract can override this). Staff can still manually pick another reading for a specific settlement. Leave empty to keep picking the latest reading regardless of provider.":
        "Gdy ustawione, automatyzacja rozliczeń uwzględnia wyłącznie nowe odczyty liczników od tego dostawcy i ignoruje odczyty od innych dostawców (umowa może to nadpisać). Pracownicy mogą nadal ręcznie wybrać inny odczyt dla konkretnego rozliczenia. Pozostaw puste, aby nadal wybierać najnowszy odczyt niezależnie od dostawcy.",
      "Contracts with a different counter priority provider": "Umowy z innym dostawcą priorytetowym liczników",
      "These contracts already have their own equipment counter priority provider, different from the new tenant default. Change them below, or leave them as they are.":
        "Te umowy mają już własnego dostawcę priorytetowego liczników urządzeń, innego niż nowa wartość domyślna przestrzeni roboczej. Zmień je poniżej lub pozostaw bez zmian.",
      "Skip": "Pomiń",
      "Save changes": "Zapisz zmiany",
      "Contracts were successfully updated.": "Umowy zostały pomyślnie zaktualizowane.",
      "Select the automation level and equipment counter priority provider for each contract.":
        "Wybierz poziom automatyzacji oraz dostawcę priorytetowego liczników dla każdej umowy.",
      "Tenant default counter priority provider: {{provider}}": "Domyślny dostawca priorytetowy liczników: {{provider}}",
      "No tenant default counter priority provider is configured yet. Set it under Settings.":
        "Domyślny dostawca priorytetowy liczników nie jest jeszcze skonfigurowany. Ustaw go w Ustawieniach.",
      "Inherit tenant default ({{provider}})": "Dziedzicz wartość domyślną ({{provider}})",
      "Inherit tenant default": "Dziedzicz wartość domyślną",
      "Counter priority provider": "Dostawca priorytetowy liczników",
      "Inherits tenant default ({{provider}})": "Dziedziczy wartość domyślną przestrzeni roboczej ({{provider}})",
      "Inherits tenant default (not set)": "Dziedziczy wartość domyślną przestrzeni roboczej (nie ustawiono)",

      // Permission groups - service role
      "Members can be assigned to jobs as technicians": "Członkowie mogą być przypisywani do zleceń jako serwisanci",

      // Tenant settings - numeration schema defaults
      "Numeration schema defaults": "Domyślne schematy numeracji",
      "Default numeration schema for jobs": "Domyślny schemat numeracji dla zleceń",
      "Default numeration schema for contracts": "Domyślny schemat numeracji dla umów",
      "Default numeration schema for ordered parts": "Domyślny schemat numeracji dla zamówień",

      // Job issue / service catalog deactivation notices
      "If this issue is not used in any job, it will be permanently removed from the catalog.":
        "Jeśli ta usterka nie jest używana w żadnym zleceniu, zostanie trwale usunięta z katalogu.",
      "If this issue is already assigned to a job, it will be deactivated instead: it stays visible in job history but will no longer appear in forms or the catalog list.":
        "Jeśli ta usterka jest już przypisana do zlecenia, zostanie dezaktywowana: pozostanie widoczna w historii zlecenia, ale nie będzie już widoczna w formularzach ani na liście katalogu.",
      "If this service is not used in any job, it will be permanently removed from the catalog.":
        "Jeśli ta usługa nie jest używana w żadnym zleceniu, zostanie trwale usunięta z katalogu.",
      "If this service is already assigned to a job, it will be deactivated instead: it stays visible in job history but will no longer appear in forms or the catalog list.":
        "Jeśli ta usługa jest już przypisana do zlecenia, zostanie dezaktywowana: pozostanie widoczna w historii zlecenia, ale nie będzie już widoczna w formularzach ani na liście katalogu.",

      // Service unavailable screen (backend down during deployment)
      "We're updating the app": "Aktualizujemy aplikację",
      "The service will be back shortly. This page will refresh automatically as soon as it's ready.":
        "Usługa wkrótce wróci. Ta strona odświeży się automatycznie, gdy tylko będzie gotowa.",
      "Checking connection…": "Sprawdzanie połączenia…",

      // Legal documents, acceptances and consents
      "Terms of service": "Regulamin",
      "Privacy policy": "Polityka prywatności",
      "Data processing agreement": "Umowa powierzenia przetwarzania danych",
      "Service level agreement": "SLA",
      "Subprocessors list": "Lista podprocesorów",
      "Security overview": "Środki bezpieczeństwa",
      "User information notice": "Informacja dla użytkownika",
      "Portal user information notice": "Informacja dla użytkownika Portalu Klienta",
      "I have read and accept:": "Zapoznałem/am się i akceptuję:",
      "I conclude the following on behalf of my company:":
        "Zawieram w imieniu reprezentowanej przeze mnie firmy:",
      "I confirm I have read:": "Potwierdzam, że zapoznałem/am się z:",
      "I want to receive commercial information about Copigo by email. Optional, can be withdrawn at any time.":
        "Chcę otrzymywać informacje handlowe o Copigo na podany adres e-mail. Zgoda dobrowolna, możesz ją wycofać w każdej chwili.",
      "You have to accept the documents required to create an account.":
        "Aby założyć konto, musisz zaakceptować wymagane dokumenty.",
      "Documents you need to confirm": "Dokumenty do potwierdzenia",
      "Before you continue, please review the documents below. You can read each of them in a new tab.":
        "Zanim przejdziesz dalej, zapoznaj się z poniższymi dokumentami. Każdy z nich otworzysz w nowej karcie.",
      "I accept": "Akceptuję",
      "What changed": "Co się zmieniło",
      "Accept and continue": "Akceptuję i kontynuuję",
      "I understand": "Rozumiem",
      "Could not save your confirmation. Please try again.":
        "Nie udało się zapisać potwierdzenia. Spróbuj ponownie.",
      "Documents and consents": "Dokumenty i zgody",
      "Version {{version}}, in force since {{date}}":
        "Wersja {{version}}, obowiązuje od {{date}}",
      "Accepted on {{date}}": "Zaakceptowano {{date}}",
      "Not accepted yet": "Jeszcze niezaakceptowany",
      "Published for your information": "Publikowany informacyjnie",
      "Previous versions": "Poprzednie wersje",
      "Could not save your choice. Please try again.":
        "Nie udało się zapisać wyboru. Spróbuj ponownie.",
      "Your choice has been saved.": "Twój wybór został zapisany.",
      // Invoices - menu, list and quick filters
      "Invoice": "Faktura",
      "Seller details": "Dane sprzedawcy",
      "Invoicing configuration": "Konfiguracja fakturowania",
      "KSeF configuration": "Konfiguracja KSeF",
      // Tenant settings - invoicing / KSeF field labels
      "Seller street": "Ulica sprzedawcy",
      "Seller city": "Miejscowość sprzedawcy",
      "Seller zip code": "Kod pocztowy sprzedawcy",
      "Seller country": "Kraj sprzedawcy",
      "Seller bank account": "Numer rachunku bankowego sprzedawcy",
      "Seller bank name": "Nazwa banku sprzedawcy",
      "Default VAT rate": "Domyślna stawka VAT",
      "Default invoice payment method": "Domyślna forma płatności faktury",
      "Invoice payment term days": "Termin płatności faktury (dni)",
      "Default numeration schema for invoices": "Domyślny schemat numeracji dla faktur",
      "Default invoice grouping": "Domyślne grupowanie faktur",
      "How settlement automation gathers confirmed settlements into invoices. A client can override it in its invoice defaults.":
        "Sposób, w jaki automatyzacja rozliczeń łączy potwierdzone rozliczenia w faktury. Klient może mieć własne ustawienie w domyślnych ustawieniach faktur.",
      "Invoice PDF template": "Szablon PDF faktury",
      "KSeF enabled": "KSeF włączony",
      "KSeF environment": "Środowisko KSeF",
      "KSeF token": "Token KSeF",
      "KSeF authentication method": "Metoda uwierzytelniania w KSeF",
      "KSeF certificate": "Certyfikat KSeF",
      "Valid until {{date}}": "Ważny do {{date}}",
      "SHA-256 fingerprint: {{fingerprint}}": "Odcisk SHA-256: {{fingerprint}}",
      "The certificate (.crt, .cer, .pem) or a PKCS#12 bundle (.p12, .pfx). Leave empty to keep the stored certificate.":
        "Certyfikat (.crt, .cer, .pem) lub plik PKCS#12 (.p12, .pfx). Pozostaw puste, aby zachować zapisany certyfikat.",
      "The private key (.key, .pem). Not needed for a PKCS#12 bundle.":
        "Klucz prywatny (.key, .pem). Niepotrzebny dla pliku PKCS#12.",
      "Password protecting the private key or the PKCS#12 bundle, if it has one. Used only to read the files, never stored.":
        "Hasło chroniące klucz prywatny lub plik PKCS#12, jeśli je ma. Służy tylko do odczytania plików i nigdy nie jest zapisywane.",
      // Dynamic form - file fields
      "Selected file: {{name}}": "Wybrany plik: {{name}}",
      "The file could not be read.": "Nie udało się odczytać pliku.",
      "Invoices": "Faktury",
      "Invoices list": "Lista faktur",
      "Sales invoices": "Faktury sprzedażowe",
      "Purchase invoices": "Faktury zakupowe",
      "Sales invoices list": "Lista faktur sprzedażowych",
      "Purchase invoices list": "Lista faktur zakupowych",
      // Breadcrumb label for the /invoices/purchase path segment
      "Purchase": "Zakupowe",
      "Invoice number": "Numer faktury",
      "All invoices": "Wszystkie faktury",
      "Paid": "Opłacone",
      "Awaiting payment": "Oczekujące na płatność",
      "Overdue": "Po terminie",
      "Invoice not found": "Nie znaleziono faktury",
      // Invoices - statuses
      // Kept untranslated on purpose - "Draft" is the term used here.
      "Draft": "Draft",
      "Issued": "Wystawiona",
      "Cancelled": "Anulowana",
      // Invoices - document kinds (FA(3) RodzajFaktury)
      "VAT invoice": "Faktura VAT",
      "Correction invoice": "Faktura korygująca",
      "Advance invoice": "Faktura zaliczkowa",
      "Settlement invoice": "Faktura rozliczeniowa",
      "Simplified invoice": "Faktura uproszczona",
      "Proforma": "Proforma",
      "Invoice kind": "Rodzaj faktury",
      // Invoices - payment methods (FA(3) FormaPlatnosci)
      "Payment method": "Forma płatności",
      "Workspace default": "Domyślny dla przestrzeni roboczej",
      "Leave empty to use the default configured for the workspace.": "Pozostaw puste, aby użyć schematu domyślnego dla przestrzeni roboczej.",
      "Bank transfer": "Przelew bankowy",
      "Cash": "Gotówka",
      "Card": "Karta",
      "Voucher": "Bon",
      "Cheque": "Czek",
      "Credit": "Kredyt",
      "Mobile payment": "Płatność mobilna",
      // Invoices - VAT rates (FA(3) P_12)
      "VAT rate": "Stawka VAT",
      "23%": "23%",
      "8%": "8%",
      "5%": "5%",
      "0% domestic": "0% krajowa",
      "0% intra-community supply": "0% WDT",
      "0% export": "0% eksport",
      "Exempt": "zw",
      "Reverse charge": "odwrotne obciążenie",
      "Not subject to tax (I)": "np I",
      "Not subject to tax (II)": "np II",
      // Invoices - form and detail view
      "New invoice": "Nowa faktura",
      "Edit invoice": "Edytuj fakturę",
      "Create invoice": "Utwórz fakturę",
      "Save invoice": "Zapisz fakturę",
      "Invoice items": "Pozycje faktury",
      "Add item": "Dodaj pozycję",
      "Remove item": "Usuń pozycję",
      "Estimated gross total": "Szacunkowa wartość brutto",
      "Place of issue": "Miejsce wystawienia",
      "Date of issue": "Data wystawienia",
      "Date of sale": "Data sprzedaży",
      "Payment due": "Termin płatności",
      "Paid at": "Data zapłaty",
      "Seller": "Sprzedawca",
      "Buyer": "Nabywca",
      "Receiver": "Odbiorca",
      "Receiver role": "Rola odbiorcy",
      "Add receiver": "Dodaj odbiorcę",
      "Remove receiver": "Usuń odbiorcę",
      "Subordinate local government unit (e.g. school, city office)": "Jednostka podrzędna JST (np. szkoła, urząd)",
      "Receiver (branch, internal unit)": "Odbiorca (oddział, jednostka wewnętrzna)",
      "VAT group member": "Członek grupy VAT",
      "Subordinate units and VAT group members need a NIP.": "Jednostka podrzędna JST i członek grupy VAT muszą mieć NIP.",
      // Invoices - per-client invoice defaults (client details tab)
      "Edit invoice defaults": "Edytuj domyślne ustawienia faktur",
      "Save invoice defaults": "Zapisz domyślne ustawienia faktur",
      "Payment term days": "Termin płatności (dni)",
      "Workspace default ({{value}})": "Domyślny dla przestrzeni roboczej ({{value}})",
      "Leave empty to use the workspace default ({{days}} days).": "Pozostaw puste, aby użyć wartości domyślnej przestrzeni roboczej (dni: {{days}}).",
      "Copy from last invoice": "Skopiuj z ostatniej faktury",
      "Copy from last issued invoice": "Skopiuj z ostatniej wystawionej faktury",
      "Select a client first": "Najpierw wybierz klienta",
      "This client has no issued invoices yet": "Ten klient nie ma jeszcze wystawionych faktur",
      "Filled in from invoice {{number}}. Dates were not copied - check the item descriptions for periods before saving.": "Uzupełniono na podstawie faktury {{number}}. Daty nie zostały skopiowane - przed zapisaniem sprawdź okresy w opisach pozycji.",
      "Undo": "Cofnij",
      "This client has no invoices yet": "Ten klient nie ma jeszcze faktur",
      "Filled in from invoice {{number}}.": "Uzupełniono na podstawie faktury {{number}}.",
      "Filled in from the draft invoice of {{date}}.": "Uzupełniono na podstawie szkicu faktury z dnia {{date}}.",
      "Values matching the workspace defaults are left to follow them. Review and save.": "Wartości zgodne z ustawieniami przestrzeni roboczej pozostawiono jako domyślne. Sprawdź i zapisz.",
      "Put on every new invoice for this client, including invoices issued by settlement automation.": "Dodawany do każdej nowej faktury tego klienta, także do faktur wystawianych przez automatyzację rozliczeń.",
      "Defaults new invoices for this client start from. Anything left on the workspace default follows the workspace invoicing settings.": "Wartości, od których zaczynają się nowe faktury tego klienta. Pola pozostawione jako domyślne korzystają z ustawień fakturowania przestrzeni roboczej.",
      "No receiver - invoices name only the buyer": "Brak odbiorcy - faktury wskazują tylko nabywcę",
      // Invoices - how settlement automation groups settlements into invoices
      "Automated invoicing": "Fakturowanie automatyczne",
      "Invoice grouping": "Grupowanie faktur",
      "One invoice per settlement": "Jedna faktura na rozliczenie",
      "One invoice per contract": "Jedna faktura na umowę",
      "One invoice per client": "Jedna faktura na klienta",
      "How settlement automation gathers this client's confirmed settlements into invoices. Invoices created by hand from a settlement always cover that one settlement.":
        "Sposób, w jaki automatyzacja rozliczeń łączy potwierdzone rozliczenia tego klienta w faktury. Faktura utworzona ręcznie z rozliczenia zawsze obejmuje tylko to jedno rozliczenie.",
      "There was an error loading the data.": "Wystąpił błąd podczas wczytywania danych.",
      "No.": "Lp.",
      "Qty": "Ilość",
      "Unit of measure": "j.m.",
      "Net value": "Wartość netto",
      "VAT amount": "Kwota VAT",
      "Gross value": "Wartość brutto",
      "VAT summary": "Podsumowanie VAT",
      "Net total": "Wartość netto",
      "VAT total": "Kwota VAT",
      "To pay": "Do zapłaty",
      "Sent to the client at {{date}} ({{email}})": "Wysłano do klienta {{date}} ({{email}})",
      // Invoices - actions
      "Issue invoice": "Wystaw fakturę",
      "Download PDF": "Pobierz PDF",
      "Regenerate PDF": "Wygeneruj PDF ponownie",
      "PDF has been regenerated": "PDF został wygenerowany ponownie",
      "Send to client": "Wyślij do klienta",
      "Send to KSeF": "Wyślij do KSeF",
      "Mark as paid": "Oznacz jako opłaconą",
      "Mark as unpaid": "Oznacz jako nieopłaconą",
      "Generate invoice": "Wygeneruj fakturę",
      "Delete invoice": "Usuń fakturę",
      "Deleting this invoice will permanently remove it from the system. This action cannot be undone.": "Usunięcie tej faktury trwale usunie ją z systemu. Tej operacji nie można cofnąć.",
      "This invoice has already been issued and its number will be left unused.": "Ta faktura została już wystawiona, a jej numer pozostanie niewykorzystany.",
      "Invoice has been deleted": "Faktura została usunięta",
      "Could not delete the invoice": "Nie udało się usunąć faktury",
      "Invoice has been issued": "Faktura została wystawiona",
      "Invoice has been created": "Faktura została utworzona",
      "Invoice has been sent to the client": "Faktura została wysłana do klienta",
      "Invoice marked as paid": "Faktura oznaczona jako opłacona",
      "Invoice marked as unpaid": "Faktura oznaczona jako nieopłacona",
      "Could not create the invoice": "Nie udało się utworzyć faktury",
      "Could not download the PDF": "Nie udało się pobrać pliku PDF",
      "Could not queue the invoice": "Nie udało się zakolejkować faktury",
      // Invoices - KSeF (Krajowy System e-Faktur)
      "Not sent": "Niewysłana",
      "Submission pending": "W trakcie",
      "Accepted": "Przyjęta",
      "Rejected": "Odrzucona",
      "Excluded": "Wyłączona",
      // Purchase invoices - retrieved from KSeF
      "Purchase invoice": "Faktura zakupowa",
      "Purchase invoice not found": "Nie znaleziono faktury zakupowej",
      "Download from KSeF": "Pobierz z KSeF",
      "Downloading from KSeF...": "Pobieranie z KSeF...",
      "Downloading invoices from KSeF has started": "Rozpoczęto pobieranie faktur z KSeF",
      "Could not start downloading invoices from KSeF": "Nie udało się rozpocząć pobierania faktur z KSeF",
      "Invoices have been downloaded from KSeF": "Faktury zostały pobrane z KSeF",
      "Downloading invoices from KSeF failed": "Pobieranie faktur z KSeF nie powiodło się",
      "Some invoices have been downloaded. The rest will follow automatically once the KSeF request limit allows.": "Pobrano część faktur. Pozostałe zostaną pobrane automatycznie, gdy pozwoli na to limit zapytań KSeF.",
      "Downloaded up to {{date}}": "Pobrano do {{date}}",
      "No invoices have been downloaded from KSeF yet": "Nie pobrano jeszcze faktur z KSeF",
      "Download resumes automatically at {{date}}": "Pobieranie zostanie wznowione automatycznie: {{date}}",
      "Last download failed: {{error}}": "Ostatnie pobieranie nie powiodło się: {{error}}",
      "Set the company NIP and a KSeF token or certificate in the workspace settings to download invoices.": "Aby pobierać faktury, ustaw NIP firmy oraz token KSeF lub certyfikat w ustawieniach przestrzeni roboczej.",
      "Download XML": "Pobierz XML",
      "Could not download the XML": "Nie udało się pobrać pliku XML",
      "Received by KSeF at": "Data przyjęcia w KSeF",
      "Stored in KSeF at": "Data trwałego zapisu w KSeF",
      "Invoicing mode": "Tryb wystawienia",
      "Has attachment": "Zawiera załącznik",
      "Self-invoicing": "Samofakturowanie",
      // Purchase invoices - KSeF invoice types beyond the kinds Copigo issues
      "Advance correction invoice": "Faktura korygująca fakturę zaliczkową",
      "Settlement correction invoice": "Faktura korygująca fakturę rozliczeniową",
      "PEF invoice": "Faktura PEF",
      "Specialised PEF invoice": "Faktura PEF specjalizowana",
      "PEF correction invoice": "Faktura PEF korygująca",
      "VAT RR invoice": "Faktura VAT RR",
      "VAT RR correction invoice": "Faktura VAT RR korygująca",
      "KSeF number": "Numer KSeF",
      "KSeF rejected this invoice": "KSeF odrzucił tę fakturę",
      "Invoice queued for KSeF": "Faktura zakolejkowana do wysyłki do KSeF",
      // Invoices - bulk actions on the list
      "Selected invoices: {{count}}": "Zaznaczone faktury: {{count}}",
      "Send to clients": "Wyślij do klientów",
      "Clear selection": "Wyczyść zaznaczenie",
      "Send selected invoices to KSeF": "Wyślij zaznaczone faktury do KSeF",
      "Send selected invoices to clients": "Wyślij zaznaczone faktury do klientów",
      "The invoices will be submitted to KSeF in the background. An invoice filed in KSeF cannot be withdrawn, only corrected.":
        "Faktury zostaną wysłane do KSeF w tle. Faktury złożonej w KSeF nie można wycofać, można ją jedynie skorygować.",
      "Each invoice will be emailed, with its PDF attached, to the client's invoicing address. Invoices whose client has no email address will be skipped.":
        "Każda faktura zostanie wysłana e-mailem wraz z plikiem PDF na adres klienta do faktur. Faktury klientów bez adresu e-mail zostaną pominięte.",
      "Invoices that cannot be sent to KSeF will be skipped (not issued, proformas, or already in KSeF): {{count}}":
        "Faktury, których nie można wysłać do KSeF, zostaną pominięte (niewystawione, proformy lub już przesłane do KSeF): {{count}}",
      "Invoices that are not issued will be skipped: {{count}}": "Niewystawione faktury zostaną pominięte: {{count}}",
      "Also resend invoices already sent to the client ({{count}})": "Wyślij ponownie także faktury już wysłane do klienta ({{count}})",
      "You can select at most {{max}} invoices at once.": "Jednorazowo możesz zaznaczyć maksymalnie {{max}} faktur.",
      "Send to KSeF ({{count}})": "Wyślij do KSeF ({{count}})",
      "Send to clients ({{count}})": "Wyślij do klientów ({{count}})",
      "Invoices queued for KSeF: {{count}}": "Faktury zakolejkowane do wysyłki do KSeF: {{count}}",
      "Invoices queued for sending: {{count}}": "Faktury zakolejkowane do wysyłki: {{count}}",
      "Their KSeF status will update on the list once KSeF responds.": "Ich status KSeF zaktualizuje się na liście po otrzymaniu odpowiedzi z KSeF.",
      "You will get a notification if any of them cannot be delivered.": "Otrzymasz powiadomienie, jeśli którejś z nich nie uda się dostarczyć.",
      "None of the selected invoices could be queued.": "Żadnej z zaznaczonych faktur nie udało się zakolejkować.",
      "Skipped invoices": "Pominięte faktury",
      "Could not queue the invoices": "Nie udało się zakolejkować faktur",

      // Client portal
      "Service portal": "Portal serwisowy",
      "Service-portal": "Portal serwisowy",
      "Client portal": "Portal klienta",
      "Client-portal": "Portal klienta",
      "This service portal is not available.": "Ten portal serwisowy jest niedostępny.",
      "Enter the email address your service provider has on file for you.":
        "Podaj adres e-mail, który Twój serwis ma zapisany w systemie.",
      "Send login code": "Wyślij kod logowania",
      "Login code": "Kod logowania",
      "If this address has portal access, we have sent it a login code. Enter it below.":
        "Jeśli ten adres ma dostęp do portalu, wysłaliśmy na niego kod logowania. Wprowadź go poniżej.",
      "Use a different address": "Użyj innego adresu",
      "The code is invalid or has expired.": "Kod jest nieprawidłowy lub wygasł.",
      "We could not send the code. Please try again in a moment.":
        "Nie udało się wysłać kodu. Spróbuj ponownie za chwilę.",
      "Service jobs": "Zlecenia serwisowe",
      "Everything your service provider is working on for you.":
        "Wszystko, nad czym pracuje dla Ciebie Twój serwis.",
      "Reported by you": "Zgłoszone przez Ciebie",
      "Show details": "Pokaż szczegóły",
      "Hide details": "Ukryj szczegóły",
      "No jobs match your search.": "Żadne zlecenie nie pasuje do wyszukiwania.",
      "Search by job number or serial number":
        "Szukaj po numerze zlecenia lub numerze seryjnym",
      "Not scheduled yet": "Termin nieustalony",
      "Raise a complaint": "Zgłoś reklamację",
      "Edit report": "Edytuj zgłoszenie",
      "Withdraw report": "Wycofaj zgłoszenie",
      "We could not withdraw this report.": "Nie udało się wycofać zgłoszenia.",
      "This will remove the report from your service provider. It cannot be undone.":
        "To usunie zgłoszenie z systemu Twojego serwisu. Tej operacji nie można cofnąć.",
      "This complaint concerns job {{number}} and the equipment it covered.":
        "Ta reklamacja dotyczy zlecenia {{number}} i urządzeń, których ono dotyczyło.",
      "Tell us which machines are affected and what is wrong with them.":
        "Wskaż, których urządzeń dotyczy zgłoszenie i na czym polega problem.",
      "There are no service jobs for your company yet.":
        "Nie ma jeszcze żadnych zleceń serwisowych dla Twojej firmy.",
      "We could not load your jobs. Please try again later.":
        "Nie udało się wczytać zleceń. Spróbuj ponownie później.",
      "We could not load this job.": "Nie udało się wczytać tego zlecenia.",
      "Your service provider has not enabled this section.":
        "Twój serwis nie udostępnił tej sekcji.",
      "Reported at": "Zgłoszono",
      "What you reported": "Treść Twojego zgłoszenia",
      "No equipment is assigned to this job.": "Do tego zlecenia nie przypisano urządzeń.",
      "Not specified": "Nie podano",

      // Client portal - support tickets
      "Report a fault": "Zgłoś usterkę",
      "What is wrong?": "Na czym polega problem?",
      "Add a photo or file": "Dodaj zdjęcie lub plik",
      "Add the photos for each machine separately.":
        "Zdjęcia dodaj osobno dla każdego urządzenia.",
      "Send report": "Wyślij zgłoszenie",
      "Thank you, your report has been sent.": "Dziękujemy, zgłoszenie zostało wysłane.",
      "We could not send your report.": "Nie udało się wysłać zgłoszenia.",
      "We could not upload the file.": "Nie udało się przesłać pliku.",

      // Client portal - staff configuration
      "Portal access": "Dostęp do portalu",
      "Portal-access": "Dostęp do portalu",
      "Grant portal access": "Przyznaj dostęp do portalu",
      "Edit portal contact": "Edytuj kontakt portalu",
      "Portal contact saved.": "Kontakt portalu został zapisany.",
      "Could not save the portal contact.": "Nie udało się zapisać kontaktu portalu.",
      "This address receives the one-time login code.":
        "Na ten adres wysyłany jest jednorazowy kod logowania.",
      "Full name": "Imię i nazwisko",
      "Last login": "Ostatnie logowanie",
      "Reported jobs": "Zgłoszone zlecenia",
      "Revoked": "Cofnięty",
      "Portal link": "Link do portalu",
      "Copy link": "Kopiuj link",
      "Portal link copied.": "Link do portalu skopiowany.",
      "Available sections": "Dostępne sekcje",
      "Technical support": "Wsparcie techniczne",
      "Enabled": "Włączony",
      "Disabled": "Wyłączony",
      "Clients can open the portal link and sign in.":
        "Klienci mogą otworzyć link do portalu i się zalogować.",
      "The portal link is closed to everyone.":
        "Link do portalu jest zamknięty dla wszystkich.",
      "Counter readings": "Odczyty liczników",
      "Client portal settings saved.": "Ustawienia portalu klienta zostały zapisane.",
      "Could not load the client portal settings.":
        "Nie udało się wczytać ustawień portalu klienta.",
      "Could not save the client portal settings.":
        "Nie udało się zapisać ustawień portalu klienta.",
      "Technical support is enabled but no default job numeration schema is set, so clients cannot report a fault yet. Set one under Settings, on the Numbering tab.":
        "Wsparcie techniczne jest włączone, ale nie ustawiono domyślnego schematu numeracji zleceń, więc klienci nie mogą jeszcze zgłosić usterki. Ustaw go w Ustawieniach, w zakładce Numeracja.",
      "You do not have permission to change these settings.":
        "Nie masz uprawnień do zmiany tych ustawień.",
      // Client portal - counter readings
      "Enter the current reading shown by each machine. You can leave any of them blank.":
        "Wprowadź aktualny stan licznika każdego urządzenia. Dowolne pole możesz zostawić puste.",
      "Serial number": "Numer seryjny",
      "Last reading": "Ostatni odczyt",
      "No reading yet": "Brak odczytu",
      "Submit readings": "Wyślij odczyty",
      "Thank you, your readings have been saved.": "Dziękujemy, odczyty zostały zapisane.",
      "We could not save your readings.": "Nie udało się zapisać odczytów.",
      "We could not load your equipment.": "Nie udało się wczytać listy urządzeń.",
      "There is no equipment assigned to your company right now.":
        "Do Twojej firmy nie jest obecnie przypisane żadne urządzenie.",
      "Your service provider has not enabled any sections yet.":
        "Twój serwis nie udostępnił jeszcze żadnej sekcji.",


      // Tenant Config workspace - sections and settings pages
      "Users & permissions": "Użytkownicy i uprawnienia",
      "Overview": "Przegląd",
      "Job status actions": "Akcje zmiany statusu",
      "Job-status-actions": "Akcje zmiany statusu",
      "Company registration": "Dane rejestrowe",
      "Billing": "Rozliczenia",

      "General": "Ogólne",
      "Dashboard thresholds and how equipment counter readings are collected.":
        "Progi pulpitu oraz sposób zbierania odczytów liczników urządzeń.",
      "Edit general settings": "Edytuj ustawienia ogólne",
      "Dashboard": "Pulpit",
      "Counter reading inbox (IMAP)": "Skrzynka odczytów liczników (IMAP)",

      "Numbering": "Numeracja",
      "Which numeration schema each kind of document gets by default.":
        "Który schemat numeracji jest domyślny dla każdego rodzaju dokumentu.",
      "Edit numbering defaults": "Edytuj domyślne schematy numeracji",

      "Invoicing": "Fakturowanie",
      "The seller block printed on every invoice, the defaults new invoices start from, the mail server invoices are emailed through, and the KSeF connection.":
        "Dane sprzedawcy drukowane na każdej fakturze, wartości domyślne nowych faktur, serwer poczty, przez który faktury są wysyłane, oraz połączenie z KSeF.",
      "Edit invoicing settings": "Edytuj ustawienia fakturowania",
      "Invoice defaults": "Domyślne ustawienia faktur",
      "Invoice email server (SMTP)": "Serwer poczty dla faktur (SMTP)",
      "Copy from reminders": "Skopiuj z przypomnień",
      "No reminders email server is configured.": "Serwer poczty dla przypomnień nie jest skonfigurowany.",
      "Leave empty to send invoices through the reminders mail server, or from the app's address if that is not configured either.":
        "Pozostaw puste, aby wysyłać faktury przez serwer poczty przypomnień, a jeśli on również nie jest skonfigurowany - z adresu aplikacji.",
      "KSeF": "KSeF",

      "The mail server outgoing messages are sent through, and the reminders built on top of it.":
        "Serwer pocztowy, przez który wysyłane są wiadomości, oraz oparte na nim przypomnienia.",
      "Edit reminder settings": "Edytuj ustawienia przypomnień",
      "Counter reminders": "Przypomnienia o licznikach",
      "Email server (SMTP)": "Serwer poczty (SMTP)",
      "Reminders": "Przypomnienia",

      "Settlement automation": "Automatyzacja rozliczeń",
      "Edit automation settings": "Edytuj ustawienia automatyzacji",
      "Automation run": "Uruchomienie automatyzacji",

      // Charts (profitability, settlements statistics, service statistics)
      "Monthly margin": "Rentowność miesięczna",
      "Revenue split": "Podział przychodu",
      "Share of parts spend": "Udział w wydatkach na części",
      "Share of parts quantity": "Udział w liczbie zużytych części",
      "Used parts metric": "Miara zużytych części",
      "Share of reported issues": "Udział zgłoszonych usterek",
      "Share of performed services": "Udział wykonanych usług",
      "Share of performed services value": "Udział w wartości wykonanych usług",
      "No priced services performed in the selected period.": "Brak wycenionych usług wykonanych w wybranym okresie.",
      "Job services metric": "Miara usług",
      "Complaint rate": "Odsetek reklamacji",
      "With complaints": "Z reklamacją",
      "Without complaints": "Bez reklamacji",
      "Page usage": "Zużycie stron",
      "Pages put through in the selected period": "Strony przetworzone w wybranym okresie",
      "Nothing recorded in the selected period.": "Brak danych w wybranym okresie.",
      "No parts used in the selected period.": "Nie zużyto części w wybranym okresie.",
      "No issues reported in the selected period.": "Nie zgłoszono usterek w wybranym okresie.",
      "No services performed in the selected period.": "Nie wykonano usług w wybranym okresie.",
      "No counter readings in the selected period.": "Brak odczytów liczników w wybranym okresie.",
      "How the selected month's revenue divides": "Jak dzieli się przychód wybranego miesiąca",
      "Cost exceeded revenue in the selected month": "Koszt przekroczył przychód w wybranym miesiącu",
      "Covered by revenue": "Pokryte przychodem",
      "Uncovered loss": "Strata niepokryta",
      "Contract no.": "Umowa nr",
      "Amount (zł)": "Kwota (zł)",
      "Pages": "Strony",
      "Profitability (net) per month": "Rentowność (netto) w podziale na miesiące",
      "Best and worst equipment": "Najlepsze i najgorsze urządzenia",
      "Best and worst contracts": "Najlepsze i najgorsze umowy",
      "Best and worst clients": "Najlepsi i najgorsi klienci",
      "Ranked by margin, worst first": "Uszeregowane według marży, od najgorszych",
      "No confirmed settlements with profitability in this period.": "Brak zatwierdzonych rozliczeń z rentownością w tym okresie.",
      "Monthly sale value": "Wartość sprzedaży miesięcznie",
      "Confirmed settlements, last 24 months": "Zatwierdzone rozliczenia, ostatnie 24 miesiące",
      "Page usage over time": "Zużycie stron w czasie",
      "Pages billed per month": "Strony rozliczone w miesiącu",
      "Pages over limit": "Strony ponad limit",
      "Usage billed beyond what the rent includes": "Zużycie rozliczane ponad to, co obejmuje czynsz",
      "No usage over the included limits in this period.": "Brak zużycia ponad limity w tym okresie.",
      "No jobs in the selected period.": "Brak zleceń w wybranym okresie.",

      // Counter strip on the sale summary (saleSummaryDetail.component.tsx).
      // "Mono"/"Color"/"Scan" are looked up by counter kind code through
      // t(variable) - see COUNTER_KIND_SHORT_LABEL_KEYS - as are the source
      // labels "User"/"Client"/"PDF"/"Email report", defined above.
      "Black": "Czarny",
      "Scan": "Skan",
      "No counter reading yet": "Brak odczytu licznika",
      "Unknown source": "Nieznane źródło",
      "Show where each settlement's counter readings came from and when they were taken":
        "Pokaż, skąd pochodzą odczyty liczników każdego rozliczenia i kiedy zostały wykonane",


      // Sale-and-service contracts: equipment sale, obligatory service
      // reminders and invoicing a finished job.
      "What this contract is for": "Czego dotyczy ta umowa",
      "Set when the contract was created and fixed from then on - its positions, settlements and reminders all depend on it.":
        "Ustalane przy tworzeniu umowy i niezmienne później - zależą od tego jej pozycje, rozliczenia i przypomnienia.",
      "Invoiced": "Zafakturowane",
      "Billed once, for the equipment price - no counters and no period.":
        "Rozliczane jednorazowo, według ceny urządzenia - bez liczników i bez okresu.",
      "Renting equipment out": "Najem urządzeń",
      "Selling equipment and servicing it": "Sprzedaż urządzeń i ich serwis",
      "Rent": "Najem",
      "Sale": "Sprzedaż",
      "The machine is sold once, and the money afterwards comes from the obligatory service that keeps its guarantee.":
        "Urządzenie jest sprzedawane jednorazowo, a późniejszy przychód pochodzi z obowiązkowych przeglądów utrzymujących gwarancję.",
      "The machine stays yours and is billed every period against its counter readings.":
        "Urządzenie pozostaje Twoje i jest rozliczane w każdym okresie na podstawie odczytów liczników.",
      "Contract kind": "Rodzaj umowy",
      "Equipment price": "Cena urządzenia",
      "Equipment price (net)": "Cena urządzenia (netto)",
      "Equipment price (gross)": "Cena urządzenia (brutto)",
      "Warranty end date": "Data końca gwarancji",
      "2 years": "2 lata",
      "3 years": "3 lata",
      "5 years": "5 lat",
      "Upcoming-services": "Nadchodzące przeglądy",
      "Equipment sale": "Sprzedaż urządzenia",
      "Obligatory service reminders": "Przypomnienia o obowiązkowych przeglądach",
      "The client is emailed ahead of each date so the service that keeps their guarantee actually happens.":
        "Klient dostaje e-mail przed każdym terminem, żeby przegląd utrzymujący gwarancję rzeczywiście się odbył.",
      "Remind this many days ahead": "Przypomnij z wyprzedzeniem (dni)",
      "Create a service job automatically": "Automatycznie utwórz zlecenie serwisowe",
      "Every (months)": "Co ile miesięcy",
      "How many times": "Ile razy",
      "Fills the list from the contract start date": "Uzupełnia listę od daty rozpoczęcia umowy",
      "Set the contract start date first": "Najpierw ustaw datę rozpoczęcia umowy",
      "Generate dates": "Wygeneruj terminy",
      "No service dates yet.": "Brak terminów przeglądów.",
      "Active service reminders need at least one date - generate the dates or switch the reminders off.":
        "Aktywne przypomnienia o przeglądach wymagają co najmniej jednego terminu - wygeneruj terminy albo wyłącz przypomnienia.",
      "Already sent - kept for the record and not editable here.":
        "Już wysłane - zachowane dla historii i nieedytowalne w tym miejscu.",
      "Price (net)": "Cena (netto)",
      "Sale price (net)": "Cena sprzedaży (netto)",
      "Charged when this part is used on an invoiced job. Empty bills it at what it was bought for.":
        "Naliczana, gdy część zostanie użyta na fakturowanym zleceniu. Puste pole oznacza rozliczenie po cenie zakupu.",
      "Invoice draft created from this job.": "Utworzono szkic faktury z tego zlecenia.",
      "Failed to create an invoice from this job.": "Nie udało się wystawić faktury z tego zlecenia.",
      "Upcoming services": "Nadchodzące przeglądy",
      "Service due": "Termin przeglądu",
      "Client is told on": "Klient powiadamiany dnia",
      "Warranty until": "Gwarancja do",
      "No warranty recorded": "Brak zapisanej gwarancji",
      "Send now": "Wyślij teraz",
      "Mark as done": "Oznacz jako wykonany",
      "Reminder sent to the client.": "Przypomnienie wysłane do klienta.",
      "Service marked as done.": "Przegląd oznaczony jako wykonany.",
      "The action could not be completed.": "Nie udało się wykonać tej akcji.",
      "Obligatory services": "Obowiązkowe przeglądy",
      "Due in the next {{count}} days": "W ciągu najbliższych {{count}} dni",
      "Sold at": "Data sprzedaży",
      "Under warranty": "Na gwarancji",
      "Warranty expired": "Gwarancja wygasła",
      "Service reminder template title": "Tytuł szablonu przypomnienia o przeglądzie",
      "Service reminder template message": "Treść szablonu przypomnienia o przeglądzie",
      "Sent to a buyer ahead of an obligatory service date on a sale-and-service contract.":
        "Wysyłane do kupującego przed terminem obowiązkowego przeglądu na umowie sprzedaży i serwisu.",
      "date the service is due": "termin przeglądu",
      "date the guarantee runs out": "data wygaśnięcia gwarancji",

      "Share this link with your clients. They sign in with a one-time code sent to an email address you have granted access to, on the client's Portal access tab.":
        "Udostępnij ten link swoim klientom. Logują się jednorazowym kodem wysyłanym na adres e-mail, któremu przyznasz dostęp w zakładce Dostęp do portalu danego klienta.",

      // Support ticket modal
      "Help": "Pomoc",
      "Contact support": "Kontakt z pomocą techniczną",
      "Feature request": "Propozycja funkcji",
      "Bug report": "Zgłoszenie błędu",
      "How can we help?": "Jak możemy pomóc?",
      "We could not send your ticket. Please try again.": "Nie udało się wysłać zgłoszenia. Spróbuj ponownie.",
      "Thank you! Your ticket {{number}} has been sent to our team.": "Dziękujemy! Twoje zgłoszenie {{number}} zostało wysłane do naszego zespołu.",

      // Detail views - shared sections and labels
      "Account": "Konto",
      "Client address": "Adres klienta",
      "Dates and payment": "Daty i płatność",
      "Identifier": "Identyfikator",
      "No configuration": "Brak konfiguracji",
      "Page costs": "Koszty stron",
      "Role": "Rola",
      "Sent to client": "Wysłano do klienta",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  // lng: "en",
  lng: "pl",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
